import React, { useEffect, Component, useState, Fragment, useLayoutEffect } from 'react';
import axios from 'axios';
import 'react-bootstrap/esm/createUtilityClasses';
import { useNavigate } from 'react-router-dom';
import 'bootstrap/dist/css/bootstrap.min.css';
import { LoadScript, GoogleMap, MarkerClusterer, Marker, InfoWindow } from '@react-google-maps/api';
import { Button as Button$1, Modal, ModalHeader, ModalBody, ModalFooter, Alert, Container, Form, FormGroup, Label, Input, Row, Col, Tooltip } from 'reactstrap';
import { FaEnvelope, FaPhone, FaGlobe, FaUser, FaExclamation, FaSearch } from 'react-icons/fa';
import { NavDropdown, Nav, ModalTitle } from 'react-bootstrap';
import Select from 'react-select';
import { Button as Button$2, axios as axios$1 } from 'react-mimg';
import parse from 'html-react-parser';
import { TailSpin } from 'react-loader-spinner';
import { ComposableMap, Geographies, Geography, Marker as Marker$1 } from 'react-simple-maps';
import moment from 'moment';
import { isMobile } from 'react-device-detect';
import { Bar } from 'react-chartjs-2';
import { VscTriangleDown, VscTriangleUp } from 'react-icons/vsc';
import { CategoryScale } from 'chart.js';
import Chart from 'chart.js/auto';

function _extends() {
  _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];
      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }
    return target;
  };
  return _extends.apply(this, arguments);
}
function _inheritsLoose(subClass, superClass) {
  subClass.prototype = Object.create(superClass.prototype);
  subClass.prototype.constructor = subClass;
  _setPrototypeOf(subClass, superClass);
}
function _setPrototypeOf(o, p) {
  _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
    o.__proto__ = p;
    return o;
  };
  return _setPrototypeOf(o, p);
}
function _assertThisInitialized(self) {
  if (self === void 0) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }
  return self;
}

var styles = {"header":"_42ic7","text":"_17fF0"};

var Test = /*#__PURE__*/function (_React$Component) {
  _inheritsLoose(Test, _React$Component);
  function Test() {
    return _React$Component.apply(this, arguments) || this;
  }
  var _proto = Test.prototype;
  _proto.render = function render() {
    return /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement("h3", {
      className: styles.header
    }, "This is a test component."), /*#__PURE__*/React.createElement("p", {
      className: styles.text
    }, this.props.text));
  };
  return Test;
}(React.Component);

var logPageViewAndReturnSupportLog = function logPageViewAndReturnSupportLog() {
  try {
    axios.post('api/log/pageView').then(function (response) {
      return response.data;
    });
    return Promise.resolve();
  } catch (e) {
    return Promise.reject(e);
  }
};
function logPageView() {
  axios.post('api/log/pageView');
}
function logError(errorLogModel) {
  axios.post('api/log/systemError', {
    Error: {
      Message: errorLogModel.error.message,
      Stack: errorLogModel.error.stack
    },
    Procedure: errorLogModel.procedure,
    CustomErrorMessage: errorLogModel.customErrorMessage
  }, {
    'Content-Type': 'application/json'
  }).then(function () {
    console.error(errorLogModel.customErrorMessage + ' ' + errorLogModel.error);
  })["catch"](function (error) {
    console.error(error);
  });
}
function logDataEditAction(dataEditActionModel) {
  axios.post('api/log/dataEditAction', dataEditActionModel).then(function () {
    console.log('Successful data edit action ' + dataEditActionModel.message);
  });
}

var ErrorLogModel = function ErrorLogModel(error, procedure, customErrorMessage) {
  if (procedure === void 0) {
    procedure = "";
  }
  if (customErrorMessage === void 0) {
    customErrorMessage = "";
  }
  this.error = error;
  this.procedure = procedure;
  this.customErrorMessage = customErrorMessage;
};

var Email = function Email(subject, body, fromEmailAddress, toEmailAddresses, userId, source, ccEmailAddresses, attachments, sendAsHtml, sendNow, genericRequestId) {
  if (subject === void 0) {
    subject = null;
  }
  if (body === void 0) {
    body = null;
  }
  if (fromEmailAddress === void 0) {
    fromEmailAddress = "mimgus@monarchinvestment.com";
  }
  if (toEmailAddresses === void 0) {
    toEmailAddresses = null;
  }
  if (userId === void 0) {
    userId = 0;
  }
  if (source === void 0) {
    source = null;
  }
  if (ccEmailAddresses === void 0) {
    ccEmailAddresses = '';
  }
  if (attachments === void 0) {
    attachments = [];
  }
  if (sendAsHtml === void 0) {
    sendAsHtml = true;
  }
  if (sendNow === void 0) {
    sendNow = true;
  }
  if (genericRequestId === void 0) {
    genericRequestId = null;
  }
  this.subject = subject;
  this.body = body;
  this.fromEmailAddress = fromEmailAddress;
  this.toEmailAddresses = toEmailAddresses;
  this.userId = userId;
  this.source = source;
  this.ccEmailAddresses = ccEmailAddresses;
  this.attachments = attachments;
  this.sendAsHtml = sendAsHtml;
  this.sendNow = sendNow;
  this.genericRequestId = genericRequestId;
};

var TabCategory = function TabCategory(name, active) {
  if (active === void 0) {
    active = true;
  }
  this.name = name;
  this.active = active;
};

var MapMarker = function MapMarker(url, textColor) {
  if (textColor === void 0) {
    textColor = '#ffffff';
  }
  this.url = url;
  this.textColor = textColor;
  this.size = 30;
};

var Property = function Property(site) {
  var pm = site.propertyEmployeeBasics ? site.propertyEmployeeBasics.filter(function (x) {
    return x.position.toLowerCase() === 'property manager';
  })[0] : null;
  var am = site.propertyEmployeeBasics ? site.propertyEmployeeBasics.filter(function (x) {
    return x.position.toLowerCase() === 'asset manager';
  })[0] : null;
  var rm = site.propertyEmployeeBasics ? site.propertyEmployeeBasics.filter(function (x) {
    return x.position.toLowerCase() === 'regional manager';
  })[0] : null;
  this.siteId = site.siteId;
  this.propertyName = site.propertyName;
  this.latitude = site.latitude;
  this.longitude = site.longitude;
  this.mapGroupId = site.mapGroupId;
  this.cityArea = site.mapGroup && site.mapGroup !== null ? site.mapGroup.description : '';
  this.yardiCode = site.yardiCode;
  this.address = site.address;
  this.zip = site.zip;
  this.city = site.city;
  this.state = site.state;
  this.phone = site.phone;
  this.url = site.url;
  this.thumbnailFilename = site.thumbnailFilename;
  this.payRentUrl = site.payRentUrl;
  this.propertyManagerName = pm ? pm.firstName + " " + pm.lastName : "";
  this.propertyManagerId = pm ? pm.propertyEmployeesId : 0;
  this.assetManagerName = am ? am.firstName + " " + am.lastName : "";
  this.assetManagerId = am ? am.propertyEmployeesId : 0;
  this.regionalManagerName = rm ? rm.firstName + " " + rm.lastName : "";
  this.regionalManagerId = rm ? rm.propertyEmployeesId : 0;
};

var instance = axios.create();
var AxiosInterceptor = function AxiosInterceptor(_ref) {
  var children = _ref.children;
  var navigate = useNavigate();
  useEffect(function () {
    var resInterceptor = function resInterceptor(response) {
      return response;
    };
    var errInterceptor = function errInterceptor(error) {
      if (error.response && error.response.status === 401) {
        navigate('/login');
      } else {
        var customMessage = 'API Error: ' + error.config.method + ' ' + error.config.url + '. ' + error.response.statusText + ' ' + error.response.data;
        logError(new ErrorLogModel(error, error.config.method + ' ' + error.config.url, customMessage));
      }
      return Promise.reject(error);
    };
    var responseInterceptor = instance.interceptors.response.use(resInterceptor, errInterceptor);
    return function () {
      instance.interceptors.response.eject(responseInterceptor);
    };
  }, [navigate]);
  return children;
};

function getMIMGUrl() {
  return process.env.REACT_APP_MIMG_URL;
}
function getEmailServiceUrl() {
  return process.env.REACT_APP_EMAIL_SERVICE_URL;
}
function getSecurityServiceUrl() {
  return process.env.REACT_APP_SECURITY_SERVICE_URL;
}
function getServiceKey() {
  return process.env.REACT_APP_SERVICE_KEY;
}

function sendEmail(email) {
  var headers = {
    'Content-Type': 'application/json',
    'APIKEY': getServiceKey()
  };
  return instance.post(getEmailServiceUrl() + "Email/send", email, {
    headers: headers
  }).then(function (response) {
    if (response.data.isSuccessful === true) {
      return response.data;
    } else {
      throw "service doesn't work - " + response.data.errorMessage;
    }
  });
}
function getNotificationAddresses(pageName, groupName) {
  var headers = {
    'Content-Type': 'application/json',
    'APIKEY': getServiceKey()
  };
  return instance.get(getEmailServiceUrl() + "Email/getNotificationEmailAddresses?PageName=" + pageName + "&NotifyGroupName=" + groupName, {
    headers: headers
  }).then(function (response) {
    if (response.data.isSuccessful === true) {
      return response.data;
    } else {
      throw "service doesn't work - " + response.data.errorMessage;
    }
  });
}

var getPermissions = function getPermissions(userId) {
  try {
    var config = {
      params: {
        userId: userId,
        userType: 'isemployee',
        minSecurityLevel: 1
      },
      headers: {
        'Content-Type': 'application/json',
        'APIKEY': getServiceKey()
      }
    };
    return Promise.resolve(instance.get(getSecurityServiceUrl() + "api/EmployeeSecurity", config)).then(function (response) {
      return response.data;
    });
  } catch (e) {
    return Promise.reject(e);
  }
};

function getNowMountainTime() {
  var moment = require('moment');
  require('moment-timezone');
  moment.tz.setDefault("America/Denver");
  return moment().format('YYYY-MM-DD h:mm:ss A');
}

var styles$1 = {"cardWrapper":"_ZTBLd","clickableContent":"_fGpWE","title":"_1ls7Q","thumbnail":"_MyyBz","cardInfoWrapper":"_1dmaA","cardInfoContainer":"_3poVK","icon":"_2ASKa","cardInfo":"_H7Xmy","linkWrapper":"_3zcU9","managerWrapper":"_UOWEo","propertyProfileLink":"_1qBMx","line":"_HZzv0"};

var styles$2 = {"link":"_2bnQU"};

var Link = /*#__PURE__*/function (_Component) {
  _inheritsLoose(Link, _Component);
  function Link() {
    return _Component.apply(this, arguments) || this;
  }
  var _proto = Link.prototype;
  _proto.render = function render() {
    if (this.props.openInNewTab) {
      return /*#__PURE__*/React.createElement("a", {
        className: styles$2.link,
        href: this.props.href,
        onClick: this.props.onClick,
        target: "_blank",
        rel: "noopener noreferrer"
      }, this.props.title);
    }
    return /*#__PURE__*/React.createElement("a", {
      className: styles$2.link,
      href: this.props.href,
      onClick: this.props.onClick
    }, this.props.title);
  };
  return Link;
}(Component);
var ActionLink = /*#__PURE__*/function (_Component2) {
  _inheritsLoose(ActionLink, _Component2);
  function ActionLink() {
    return _Component2.apply(this, arguments) || this;
  }
  var _proto2 = ActionLink.prototype;
  _proto2.render = function render() {
    return /*#__PURE__*/React.createElement("span", {
      className: styles$2.link,
      onClick: this.props.onClick
    }, this.props.title);
  };
  return ActionLink;
}(Component);

var styles$3 = {"wrapper":"_3dNgJ","infoAndLinks":"_1NIn8","info":"_3fbFC","linkWrapper":"_3LPmj","floorPlanWrapper":"_3m9mf","title":"_1PxKu","img":"_16_Yo"};

var styles$4 = {"yellow":"_Ahk87","red":"_2Dlx_","transparent":"_2AEHG","button":"_1y8cF","deleteButton":"_1trwx","editButton":"_6E_qQ"};

var EditButton = /*#__PURE__*/function (_Component) {
  _inheritsLoose(EditButton, _Component);
  function EditButton() {
    var _this;
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = _Component.call.apply(_Component, [this].concat(args)) || this;
    _this.onClick = function (e) {
      e.preventDefault();
      if (_this.props.onClick) {
        _this.props.onClick(e);
      }
    };
    return _this;
  }
  var _proto = EditButton.prototype;
  _proto.render = function render() {
    return /*#__PURE__*/React.createElement(Button$1, {
      id: this.props.id,
      outline: true,
      color: "secondary",
      className: this.props.className + " " + styles$4.deleteButton,
      onClick: this.onClick,
      title: "Edit Item"
    }, "Edit");
  };
  return EditButton;
}(Component);
var DeleteButton = /*#__PURE__*/function (_Component2) {
  _inheritsLoose(DeleteButton, _Component2);
  function DeleteButton() {
    var _this2;
    for (var _len2 = arguments.length, args = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
      args[_key2] = arguments[_key2];
    }
    _this2 = _Component2.call.apply(_Component2, [this].concat(args)) || this;
    _this2.onClick = function (e) {
      e.preventDefault();
      if (_this2.props.onClick) {
        _this2.props.onClick(e);
      }
    };
    return _this2;
  }
  var _proto2 = DeleteButton.prototype;
  _proto2.render = function render() {
    return /*#__PURE__*/React.createElement(Button$1, {
      id: this.props.id,
      outline: true,
      color: "secondary",
      className: this.props.className + " " + styles$4.deleteButton,
      onClick: this.onClick,
      title: "Delete Item"
    }, "X");
  };
  return DeleteButton;
}(Component);
var LinkButton = /*#__PURE__*/function (_Component3) {
  _inheritsLoose(LinkButton, _Component3);
  function LinkButton() {
    return _Component3.apply(this, arguments) || this;
  }
  var _proto3 = LinkButton.prototype;
  _proto3.render = function render() {
    var _this3 = this;
    if (this.props.red) return /*#__PURE__*/React.createElement(Button$1, {
      id: this.props.id,
      className: styles$4.button + " " + styles$4.red,
      title: this.props.title,
      onClick: function onClick() {
        return window.open(_this3.props.href, "_blank");
      }
    }, this.props.children);
    if (this.props.transparent) return /*#__PURE__*/React.createElement(Button$1, {
      id: this.props.id,
      className: styles$4.button + " " + styles$4.transparent,
      title: this.props.title,
      onClick: function onClick() {
        return window.open(_this3.props.href, "_blank");
      }
    }, this.props.children);
    return /*#__PURE__*/React.createElement(Button$1, {
      id: this.props.id,
      className: styles$4.button + " " + styles$4.yellow,
      title: this.props.title,
      onClick: function onClick() {
        return window.open(_this3.props.href, "_blank");
      }
    }, this.props.children);
  };
  return LinkButton;
}(Component);
var Button = /*#__PURE__*/function (_Component4) {
  _inheritsLoose(Button, _Component4);
  function Button() {
    var _this4;
    for (var _len3 = arguments.length, args = new Array(_len3), _key3 = 0; _key3 < _len3; _key3++) {
      args[_key3] = arguments[_key3];
    }
    _this4 = _Component4.call.apply(_Component4, [this].concat(args)) || this;
    _this4.onClick = function (e) {
      if (_this4.props.onClick) {
        e.preventDefault();
        _this4.props.onClick(e);
      }
    };
    return _this4;
  }
  var _proto4 = Button.prototype;
  _proto4.render = function render() {
    if (this.props.red && !this.props.isActive) return /*#__PURE__*/React.createElement(Button$1, {
      id: this.props.id,
      className: styles$4.button + " " + styles$4.red + " " + this.props.className,
      title: this.props.title,
      onClick: this.onClick,
      disabled: this.props.disabled,
      type: this.props.type
    }, this.props.children);
    if (this.props.transparent && !this.props.isActive) return /*#__PURE__*/React.createElement(Button$1, {
      id: this.props.id,
      outline: true,
      className: styles$4.button + " " + this.props.className,
      title: this.props.title,
      onClick: this.onClick,
      disabled: this.props.disabled,
      type: this.props.type
    }, this.props.children);
    return /*#__PURE__*/React.createElement(Button$1, {
      id: this.props.id,
      className: styles$4.button + " " + styles$4.yellow + " " + this.props.className,
      title: this.props.title,
      onClick: this.onClick,
      disabled: this.props.disabled,
      type: this.props.type
    }, this.props.children);
  };
  return Button;
}(Component);

var FloorplanInfo = /*#__PURE__*/function (_Component) {
  _inheritsLoose(FloorplanInfo, _Component);
  function FloorplanInfo(props) {
    var _this;
    _this = _Component.call(this, props) || this;
    _this.setActiveFloorplan = function (floorplan) {
      _this.setState({
        activeFloorplan: floorplan
      });
    };
    _this.state = {
      floorplans: null,
      activeFloorplan: null
    };
    return _this;
  }
  var _proto = FloorplanInfo.prototype;
  _proto.componentDidMount = function componentDidMount() {
    var _this2 = this;
    instance.get('api/property/getFloorplans/' + this.props.site.yardiCode).then(function (response) {
      var floorplans = response.data;
      if (floorplans.length > 0) {
        _this2.setState({
          floorplans: floorplans,
          activeFloorplan: floorplans[0]
        });
      }
    });
  };
  _proto.render = function render() {
    var _this3 = this;
    if (!this.state.floorplans) return /*#__PURE__*/React.createElement("div", null, "Loading Floorplans");
    if (this.state.floorplans.length === 1 && this.state.floorplans[0].floorplanName === null) return /*#__PURE__*/React.createElement("div", null, "There are no available floorplans");else {
      return /*#__PURE__*/React.createElement("div", {
        className: styles$3.wrapper
      }, /*#__PURE__*/React.createElement("div", {
        className: styles$3.infoAndLinks
      }, this.state.floorplans.map(function (floorplan, i) {
        var sizeString = "Size: " + floorplan.minimumSQFT;
        if (floorplan.maximumSQFT > floorplan.minimumSQFT) {
          sizeString += " to " + floorplan.maximumSQFT;
        }
        sizeString += " sq ft";
        var rentString = "Rent: $" + floorplan.minimumRent;
        if (floorplan.maximumRent > floorplan.minimumRent) {
          rentString += " to $" + floorplan.maximumRent;
        }
        return /*#__PURE__*/React.createElement("div", {
          key: i
        }, /*#__PURE__*/React.createElement("h5", null, floorplan.floorplanName), /*#__PURE__*/React.createElement("div", {
          className: styles$3.info
        }, /*#__PURE__*/React.createElement("p", null, "Bedrooms: ", floorplan.beds, ", Bathrooms: ", floorplan.baths, " ", /*#__PURE__*/React.createElement("br", null), sizeString, " ", /*#__PURE__*/React.createElement("br", null), rentString), /*#__PURE__*/React.createElement("div", {
          className: styles$3.linkWrapper
        }, /*#__PURE__*/React.createElement(ActionLink, {
          onClick: function onClick() {
            return _this3.setActiveFloorplan(floorplan);
          },
          title: "View Floorplan"
        }), /*#__PURE__*/React.createElement("br", null), /*#__PURE__*/React.createElement(Link, {
          openInNewTab: true,
          href: floorplan.availabilityURL,
          title: "See Availability"
        }))));
      })), /*#__PURE__*/React.createElement("div", {
        className: styles$3.floorPlanWrapper
      }, /*#__PURE__*/React.createElement("div", {
        className: styles$3.title
      }, /*#__PURE__*/React.createElement("h5", null, this.state.activeFloorplan.floorplanName), /*#__PURE__*/React.createElement(LinkButton, {
        title: "Apply Now!",
        href: this.state.activeFloorplan.availabilityURL
      }, "Apply Now!")), /*#__PURE__*/React.createElement("img", {
        className: styles$3.img,
        src: this.state.activeFloorplan.floorplanImageURL,
        alt: "Floorplan"
      })));
    }
  };
  return FloorplanInfo;
}(Component);

var CryptoJS = require("crypto-js");
function PropertyCard(props) {
  var _site$thumbnailFilena;
  var _useState = useState(false),
    showFloorplan = _useState[0],
    setShowFloorplan = _useState[1];
  useEffect(function () {
    if (showFloorplan && props.logActions) {
      var actionDetails = {};
      actionDetails.siteId = site.siteId;
      logPropertyCardActivity('ViewFloorplanModal', actionDetails);
    }
  }, [showFloorplan]);
  function onLogResidentWebsiteLinkClick(e) {
    if (props.logActions) {
      var actionDetails = {};
      actionDetails.siteId = site.siteId;
      actionDetails.url = site.url;
      logPropertyCardActivity('OpenResidentWebsite', actionDetails);
    }
  }
  function onLogPhoneNumberClick() {
    if (props.logActions) {
      var actionDetails = {};
      actionDetails.siteId = site.siteId;
      actionDetails.url = site.phone;
      logPropertyCardActivity('ClickPropertyPhoneNumber', actionDetails);
    }
  }
  function onPayRentUrlClicked() {
    if (props.logActions) {
      var actionDetails = {};
      actionDetails.siteId = site.siteId;
      actionDetails.url = site.payRentUrl;
      logPropertyCardActivity('ClickResidentLogin', actionDetails);
    }
  }
  function logPropertyCardActivity(actionType, actionDetails) {
    if (props.logActions) {
      var logObject = {};
      if (localStorage.getItem("monarchBrowserStorage")) {
        logObject = JSON.parse(CryptoJS.AES.decrypt(localStorage.getItem("monarchBrowserStorage"), process.env.REACT_APP_LOCAL_STORAGE_KEY).toString(CryptoJS.enc.Utf8));
        logObject.createDateTime = null;
        logObject.actionType = actionType;
        logObject.actionDetails = JSON.stringify(actionDetails);
        instance.post('api/log/LogActivity', logObject);
      }
    }
  }
  var site = props.site;
  var thumbnail = 'https://mimgus.blob.core.windows.net/property-photos/' + (site === null || site === void 0 ? void 0 : (_site$thumbnailFilena = site.thumbnailFilename) === null || _site$thumbnailFilena === void 0 ? void 0 : _site$thumbnailFilena.toLowerCase());
  return /*#__PURE__*/React.createElement("div", {
    onMouseEnter: props.onMouseEnter,
    onMouseLeave: props.onMouseLeave,
    className: styles$1.cardWrapper
  }, /*#__PURE__*/React.createElement("div", {
    onClick: props.onClick,
    className: styles$1.clickableContent
  }, /*#__PURE__*/React.createElement("p", {
    className: styles$1.title
  }, site.propertyName), /*#__PURE__*/React.createElement("img", {
    className: styles$1.thumbnail,
    src: thumbnail,
    alt: site.propertyName
  }), /*#__PURE__*/React.createElement("div", {
    className: styles$1.line
  }), /*#__PURE__*/React.createElement("div", {
    className: styles$1.cardInfoWrapper
  }, /*#__PURE__*/React.createElement("div", {
    className: styles$1.cardInfoContainer
  }, /*#__PURE__*/React.createElement("div", {
    className: styles$1.icon
  }, /*#__PURE__*/React.createElement(FaEnvelope, {
    size: "16px"
  })), /*#__PURE__*/React.createElement("div", {
    className: styles$1.cardInfo
  }, /*#__PURE__*/React.createElement("div", null, " ", site.address), /*#__PURE__*/React.createElement("div", null, site.city, ", ", site.state, " ", site.zip))), /*#__PURE__*/React.createElement("div", {
    className: styles$1.cardInfoContainer
  }, /*#__PURE__*/React.createElement("div", {
    className: styles$1.icon
  }, /*#__PURE__*/React.createElement(FaPhone, {
    size: "16px"
  })), /*#__PURE__*/React.createElement("div", {
    className: styles$1.cardInfo
  }, /*#__PURE__*/React.createElement(Link, {
    onClick: onLogPhoneNumberClick,
    href: 'tel:' + site.phone,
    title: site.phone
  }))), /*#__PURE__*/React.createElement("div", {
    className: styles$1.cardInfoContainer
  }, /*#__PURE__*/React.createElement("div", {
    className: styles$1.icon
  }, /*#__PURE__*/React.createElement(FaGlobe, {
    size: "16px"
  })), /*#__PURE__*/React.createElement("div", {
    className: styles$1.cardInfo
  }, /*#__PURE__*/React.createElement(Link, {
    onClick: onLogResidentWebsiteLinkClick,
    openInNewTab: true,
    href: "https://" + site.url,
    title: "Property Website"
  })))), /*#__PURE__*/React.createElement("div", {
    className: styles$1.line
  })), props.internal ? /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement("div", {
    className: styles$1.managerWrapper
  }, /*#__PURE__*/React.createElement("div", {
    className: styles$1.icon
  }, /*#__PURE__*/React.createElement(FaUser, {
    size: "16px"
  })), /*#__PURE__*/React.createElement("div", {
    className: styles$1.cardInfo
  }, /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement("span", null, "PM: "), " ", /*#__PURE__*/React.createElement(Link, {
    href: 'profiles/employee?Id=' + site.propertyManagerId,
    title: site.propertyManagerName
  })), /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement("span", null, "AM: "), " ", /*#__PURE__*/React.createElement(Link, {
    href: 'profiles/employee?Id=' + site.assetManagerId,
    title: site.assetManagerName
  })), /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement("span", null, "RM: "), " ", /*#__PURE__*/React.createElement(Link, {
    href: 'profiles/employee?Id=' + site.regionalManagerId,
    title: site.regionalManagerName
  })))), /*#__PURE__*/React.createElement("div", {
    className: styles$1.propertyProfileLink
  }, /*#__PURE__*/React.createElement(LinkButton, {
    href: 'profiles/property/' + site.siteId
  }, "View Property Profile"))) : /*#__PURE__*/React.createElement("div", {
    className: styles$1.linkWrapper
  }, /*#__PURE__*/React.createElement(Link, {
    onClick: onPayRentUrlClicked,
    openInNewTab: true,
    href: site.payRentUrl,
    title: "Resident Login"
  }), /*#__PURE__*/React.createElement(ActionLink, {
    onClick: function onClick() {
      return setShowFloorplan(true);
    },
    title: "Floorplan & Availability"
  }), /*#__PURE__*/React.createElement(Modal, {
    className: "modal-xl",
    isOpen: showFloorplan,
    toggle: function toggle() {
      return setShowFloorplan(false);
    }
  }, /*#__PURE__*/React.createElement(ModalHeader, {
    toggle: function toggle() {
      return setShowFloorplan(false);
    }
  }, site.propertyName, " Floorplans"), /*#__PURE__*/React.createElement(ModalBody, null, /*#__PURE__*/React.createElement(FloorplanInfo, {
    site: site
  })), /*#__PURE__*/React.createElement(ModalFooter, null, /*#__PURE__*/React.createElement(Button, {
    transparent: true,
    title: "Close",
    onClick: function onClick() {
      return setShowFloorplan(false);
    }
  }, "Close")))));
}

var styles$5 = {"wrapper":"_3GAHU","searchFilter":"_1xi6v","mapWrapper":"_3uRSi","cardContainer":"_f2-oK","noCards":"_3j6VO","infoWindow":"_3f0R0","propertyShowButton":"_1j8HA"};

var styles$6 = {"input":"_3Vndr","searchWrapper":"_yVHzj","searchInput":"_1si31","searchButton":"_3KwIS"};

var TextInput = /*#__PURE__*/function (_Component) {
  _inheritsLoose(TextInput, _Component);
  function TextInput() {
    return _Component.apply(this, arguments) || this;
  }
  var _proto = TextInput.prototype;
  _proto.render = function render() {
    return /*#__PURE__*/React.createElement("input", {
      ref: this.props.innerRef,
      className: styles$6.input + " " + this.props.className,
      type: "text",
      placeholder: this.props.placeholder,
      onChange: this.props.onChange,
      onKeyDown: this.props.onKeyDown
    });
  };
  return TextInput;
}(Component);
var TextInput$1 = React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(TextInput, _extends({}, props, {
    innerRef: ref
  }));
});

var libraries = ["geometry"];
var PropertySearch = /*#__PURE__*/function (_Component) {
  _inheritsLoose(PropertySearch, _Component);
  function PropertySearch(props) {
    var _this;
    _this = _Component.call(this, props) || this;
    _this.closeAlert = function () {
      _this.setState({
        showAlert: false
      });
    };
    _this.onClickNearMe = function () {
      _this.getCurrentLocation().then(function (data) {
        if (data) {
          var myLocation = new window.google.maps.LatLng(data.coords.latitude, data.coords.longitude);
          _this.zoomIn(myLocation, 8);
        }
      });
    };
    _this.mapRef = React.createRef();
    _this.searchTimeout = 0;
    _this.searchZipLocation = null;
    _this.currentLocation = null;
    _this.allProperties = props.allProperties.filter(function (x) {
      return x.latitude && x.longitude;
    });
    _this.state = {
      sitesInBounds: [],
      activeSite: null,
      filterString: '',
      showPropertyList: true,
      currentLocation: null,
      showAlert: false
    };
    return _this;
  }
  var _proto = PropertySearch.prototype;
  _proto.componentDidUpdate = function componentDidUpdate(prevProps) {
    if (prevProps.propertiesInScope !== this.props.propertiesInScope) {
      this.setBoundsFromPageParameters();
    }
  };
  _proto.getCurrentLocation = function getCurrentLocation() {
    return new Promise(function (res, rej) {
      navigator.geolocation.getCurrentPosition(res, rej);
    });
  };
  _proto.zoomIn = function zoomIn(location, zoom) {
    this.mapRef.current.setCenter(location);
    this.mapRef.current.setZoom(zoom);
  };
  _proto.getPosition = function getPosition(property) {
    var lat = property.latitude;
    var lng = property.longitude;
    if (lat && lng && typeof lat === 'number' && typeof lng === 'number') {
      return new window.google.maps.LatLng(lat, lng);
    } else return null;
  };
  _proto.setBounds = function setBounds(locations) {
    var _this2 = this;
    var sites = locations.length > 0 ? locations : this.allProperties;
    var bounds = new window.google.maps.LatLngBounds();
    sites.map(function (site) {
      var pos = _this2.getPosition(site);
      if (pos && pos !== null) {
        bounds.extend(pos);
      }
      return null;
    });
    this.mapRef.current.fitBounds(bounds);
    if (this.mapRef.current.zoom > 13) {
      this.mapRef.current.setZoom(13);
    }
  };
  _proto.setBoundsFromPageParameters = function setBoundsFromPageParameters() {
    if (this.props.propertiesInScope.length !== this.props.allProperties.length) {
      this.setBounds(this.props.propertiesInScope);
    } else {
      this.setBounds(this.props.allProperties);
    }
  };
  _proto.handleLoad = function handleLoad(map) {
    this.mapRef.current = map;
    this.setBoundsFromPageParameters();
  };
  _proto.setSitesInScope = function setSitesInScope() {
    var _this3 = this;
    if (!this.mapRef.current) return;
    var bounds = this.mapRef.current.getBounds().toJSON();
    var sitesInScope = [];
    this.allProperties.map(function (property) {
      var pos = _this3.getPosition(property);
      if (pos && pos !== null && pos.lat() > bounds.south && pos.lat() < bounds.north && pos.lng() > bounds.west && pos.lng() < bounds.east) {
        sitesInScope.push(property);
      }
      return null;
    });
    var showAlert = this.allProperties.length <= sitesInScope.length && this.state.filterString !== '';
    this.setState({
      sitesInBounds: sitesInScope,
      showAlert: showAlert,
      filterString: ''
    });
  };
  _proto.updateSearchResult = function updateSearchResult(event) {
    var _this4 = this;
    event.persist();
    if (this.searchTimeout) {
      clearTimeout(this.searchTimeout);
    }
    var zips = this.props.zipCodes;
    this.searchTimeout = setTimeout(function () {
      var isZip = /(^\d{5}$)/.test(event.target.value);
      _this4.searchZipLocation = null;
      if (isZip) {
        var zipLatLng = zips.filter(function (x) {
          return Number(x.zip) === Number(event.target.value);
        });
        if (zipLatLng && zipLatLng !== null && zipLatLng.length === 1) {
          _this4.searchZipLocation = new window.google.maps.LatLng(zipLatLng[0].lat, zipLatLng[0].lng);
        }
      }
      _this4.setState({
        filterString: event.target.value
      }, function () {
        var properties = _this4.allProperties.filter(function (site) {
          return _this4.isPropertyIncludedInSearch(site);
        });
        _this4.setBounds(properties);
        if (_this4.props.logSearchBarUpdate) {
          _this4.props.logSearchBarUpdate(event.target.value, isZip, properties.length);
        }
      });
    }, 500);
  };
  _proto.clearSearch = function clearSearch() {
    this.searchInput.value = '';
    this.searchZipLocation = null;
    this.setState({
      filterString: ''
    });
  };
  _proto.showAll = function showAll() {
    this.clearSearch();
    this.setBounds(this.allProperties);
  };
  _proto.resetSearchToRegion = function resetSearchToRegion() {
    this.clearSearch();
    this.setBoundsFromPageParameters();
  };
  _proto.isPropertyIncludedInSearch = function isPropertyIncludedInSearch(site) {
    var pos = this.getPosition(site);
    if (this.searchZipLocation !== null && pos !== null) {
      var distance = window.google.maps.geometry.spherical.computeDistanceBetween(this.searchZipLocation, pos);
      return distance < 48280;
    }
    return this.state.filterString === '' || site.propertyName.toLowerCase().includes(this.state.filterString.toLowerCase()) || site.city.toLowerCase().includes(this.state.filterString.toLowerCase()) || site.cityArea && site.cityArea.toLowerCase().includes(this.state.filterString.toLowerCase()) || site.zip === this.state.filterString;
  };
  _proto.render = function render() {
    var _this5 = this;
    return /*#__PURE__*/React.createElement("div", {
      className: styles$5.wrapper
    }, /*#__PURE__*/React.createElement("div", {
      className: styles$5.menu
    }, /*#__PURE__*/React.createElement("div", {
      className: styles$5.searchFilter
    }, /*#__PURE__*/React.createElement(TextInput$1, {
      ref: function ref(s) {
        return _this5.searchInput = s;
      },
      placeholder: "Search for properties by Name, City or Zip code.",
      onChange: function onChange(event) {
        return _this5.updateSearchResult(event);
      }
    }), /*#__PURE__*/React.createElement(Button, {
      title: "Show properties near me",
      onClick: this.onClickNearMe
    }, "Near Me"), /*#__PURE__*/React.createElement(Button, {
      title: "Show all properties",
      onClick: function onClick() {
        return _this5.showAll();
      }
    }, "Show All"), this.props.allProperties.length !== this.props.propertiesInScope.length ? /*#__PURE__*/React.createElement(Button, {
      title: "Show properties based on menu search",
      onClick: function onClick() {
        return _this5.resetSearchToRegion();
      }
    }, "Back to Region") : null, /*#__PURE__*/React.createElement("div", {
      className: styles$5.propertyShowButton
    }, /*#__PURE__*/React.createElement(Button, {
      title: "Show/Hide property list",
      onClick: function onClick() {
        return _this5.setState({
          showPropertyList: !_this5.state.showPropertyList
        });
      }
    }, "Hide/Show Property List"))), /*#__PURE__*/React.createElement(Alert, {
      toggle: this.closeAlert,
      isOpen: this.state.showAlert,
      color: "info"
    }, "Your search did not match any properties. Please try another search string or use the map to zoom in on an area.")), /*#__PURE__*/React.createElement("div", {
      className: styles$5.mapWrapper,
      style: this.props.style
    }, /*#__PURE__*/React.createElement(LoadScript, {
      googleMapsApiKey: process.env.REACT_APP_GOOGLE_KEY,
      libraries: libraries
    }, /*#__PURE__*/React.createElement(GoogleMap, {
      ref: function ref(_ref) {
        return _this5.map = _ref;
      },
      onBoundsChanged: function onBoundsChanged() {
        return _this5.setSitesInScope();
      },
      mapContainerStyle: {
        width: '100%',
        height: '100%'
      },
      onLoad: function onLoad(map) {
        return _this5.handleLoad(map);
      },
      onClick: function onClick() {
        return _this5.setState({
          activeSite: null
        });
      },
      options: {
        fullscreenControl: false
      }
    }, /*#__PURE__*/React.createElement(MarkerClusterer, {
      maxZoom: 13,
      options: {
        gridSize: 30,
        minimumClusterSize: 2,
        imageExtension: 'png',
        styles: [{
          url: this.props.marker.url,
          width: this.props.marker.size,
          height: this.props.marker.size,
          textColor: this.props.marker.textColor,
          fontFamily: 'sans-serif'
        }]
      }
    }, function (clusterer) {
      return _this5.state.sitesInBounds.map(function (property) {
        var pos = _this5.getPosition(property);
        if (pos && pos !== null) return /*#__PURE__*/React.createElement(Marker, {
          key: property.siteId,
          position: pos,
          clusterer: clusterer,
          onClick: function onClick() {
            return _this5.setState({
              activeSite: property
            });
          },
          icon: {
            url: _this5.props.marker.url,
            scaledSize: {
              height: _this5.props.marker.size,
              width: _this5.props.marker.size
            }
          },
          title: property.propertyName + '. Click for more details',
          label: {
            color: _this5.props.marker.textColor,
            fontSize: '11px',
            text: '1',
            fontFamily: 'sans-serif'
          }
        });else return null;
      });
    }), this.state.activeSite !== null ? /*#__PURE__*/React.createElement(InfoWindow, {
      position: this.getPosition(this.state.activeSite),
      options: {
        pixelOffset: new window.google.maps.Size(0, -30)
      },
      onCloseClick: function onCloseClick() {
        return _this5.setState({
          activeSite: null
        });
      }
    }, /*#__PURE__*/React.createElement("div", {
      className: styles$5.infoWindow
    }, /*#__PURE__*/React.createElement(PropertyCard, {
      internal: this.props.internal,
      onClick: function onClick() {
        return _this5.zoomIn(_this5.getPosition(_this5.state.activeSite), 15);
      },
      key: this.state.activeSite.siteId,
      logActions: this.props.logActions,
      site: this.state.activeSite
    }))) : null)), this.state.showPropertyList === true ? /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement("div", {
      className: styles$5.cardContainer
    }, this.state.sitesInBounds.length > 0 ? this.state.sitesInBounds.map(function (site) {
      return /*#__PURE__*/React.createElement(PropertyCard, {
        internal: _this5.props.internal,
        onMouseEnter: function onMouseEnter() {
          return _this5.setState({
            activeSite: site
          });
        },
        onMouseLeave: function onMouseLeave() {
          return _this5.setState({
            activeSite: null
          });
        },
        onClick: function onClick() {
          return _this5.zoomIn(_this5.getPosition(_this5.state.activeSite), 15);
        },
        logActions: _this5.props.logActions,
        key: site.siteId,
        site: site
      });
    }).slice(0, 25) : /*#__PURE__*/React.createElement("div", {
      className: styles$5.noCards
    }, /*#__PURE__*/React.createElement(FaExclamation, {
      size: "32px"
    }), /*#__PURE__*/React.createElement("br", null), /*#__PURE__*/React.createElement("br", null), /*#__PURE__*/React.createElement("p", null, "No properties found in the area. ", /*#__PURE__*/React.createElement("br", null), "Zoom out on the map or use the search bar above to find our properties.")))) : null));
  };
  return PropertySearch;
}(Component);

var styles$7 = {"dropDown":"_6aLzK"};

function NavDropdownTitle(props) {
  var _useState = useState(false),
    show = _useState[0],
    setShow = _useState[1];
  return /*#__PURE__*/React.createElement("div", {
    id: "navDropDownTitle",
    className: props.className
  }, /*#__PURE__*/React.createElement(NavDropdown, {
    className: styles$7.dropDown,
    show: show,
    onMouseEnter: function onMouseEnter() {
      return setShow(!show);
    },
    onMouseLeave: function onMouseLeave() {
      return setShow(!show);
    },
    title: props.title
  }, props.children));
}

var styles$8 = {"dropDownItem":"_2UAgT","dropDownItemBold":"_3cMrp","dropdown":"_1Aach","dropDown":"_MuEPo","dropDownBold":"_2ZZj-"};

var NavDropdownItem = /*#__PURE__*/function (_Component) {
  _inheritsLoose(NavDropdownItem, _Component);
  function NavDropdownItem() {
    return _Component.apply(this, arguments) || this;
  }
  var _proto = NavDropdownItem.prototype;
  _proto.render = function render() {
    if (this.props.bold) {
      return /*#__PURE__*/React.createElement("div", {
        id: "navDropdownItem",
        className: this.props.className
      }, /*#__PURE__*/React.createElement(NavDropdown.Item, {
        className: styles$8.dropDownItemBold,
        href: this.props.link
      }, this.props.title));
    }
    return /*#__PURE__*/React.createElement("div", {
      id: "navDropdownItem",
      className: this.props.className
    }, /*#__PURE__*/React.createElement(NavDropdown.Item, {
      className: styles$8.dropDownItem,
      href: this.props.link
    }, this.props.title));
  };
  return NavDropdownItem;
}(Component);

var styles$9 = {"dropDownHeader":"_3sGM0"};

var NavDropdownItemHeader = /*#__PURE__*/function (_Component) {
  _inheritsLoose(NavDropdownItemHeader, _Component);
  function NavDropdownItemHeader() {
    return _Component.apply(this, arguments) || this;
  }
  var _proto = NavDropdownItemHeader.prototype;
  _proto.render = function render() {
    return /*#__PURE__*/React.createElement("div", {
      id: "navDropdownHeader",
      className: this.props.className
    }, /*#__PURE__*/React.createElement(NavDropdown.Item, {
      className: styles$9.dropDownHeader
    }, this.props.title));
  };
  return NavDropdownItemHeader;
}(Component);

var styles$a = {"link":"_2Ymnb"};

var NavLink = /*#__PURE__*/function (_Component) {
  _inheritsLoose(NavLink, _Component);
  function NavLink() {
    return _Component.apply(this, arguments) || this;
  }
  var _proto = NavLink.prototype;
  _proto.render = function render() {
    return /*#__PURE__*/React.createElement("div", {
      id: "navLink",
      className: this.props.className
    }, /*#__PURE__*/React.createElement(Nav.Item, {
      className: styles$a.link
    }, /*#__PURE__*/React.createElement(Nav.Link, {
      href: this.props.link
    }, this.props.title)));
  };
  return NavLink;
}(Component);

var styles$b = {"tab":"_1M_lq","active":"_2XOFM","deleteButton":"_3JPGH"};

var Tab = /*#__PURE__*/function (_Component) {
  _inheritsLoose(Tab, _Component);
  function Tab() {
    var _this;
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = _Component.call.apply(_Component, [this].concat(args)) || this;
    _this.deleteCategory = function (event) {
      event.stopPropagation();
      _this.props.onCategoryDelete(event);
    };
    return _this;
  }
  var _proto = Tab.prototype;
  _proto.render = function render() {
    var category = this.props.category;
    var isAdmin = this.props.isAdmin;
    var className = this.props.isActive ? styles$b.tab + " " + styles$b.active : styles$b.tab;
    return /*#__PURE__*/React.createElement("div", {
      className: className,
      onClick: this.props.onClick
    }, /*#__PURE__*/React.createElement("div", null, isAdmin && !category.active && /*#__PURE__*/React.createElement(DeleteButton, {
      onClick: this.deleteCategory
    }, /*#__PURE__*/React.createElement("span", {
      className: styles$b.deleteButton
    }, "X")), /*#__PURE__*/React.createElement("span", null, category.name)));
  };
  return Tab;
}(Component);

var styles$c = {"menuWrapper":"_d6ILI","tabWrapper":"_1RqBK","line":"_Auh7g"};

var TabMenu = /*#__PURE__*/function (_Component) {
  _inheritsLoose(TabMenu, _Component);
  function TabMenu(props) {
    var _this;
    _this = _Component.call(this, props) || this;
    _this.state = {
      activeTab: _this.props.activeTab ? _this.props.activeTab : 0
    };
    return _this;
  }
  var _proto = TabMenu.prototype;
  _proto.toggleTab = function toggleTab(index, tabName) {
    if (this.state.activeTab !== index) {
      this.setState({
        activeTab: index
      });
      this.props.onTabChanged(index, tabName);
    }
  };
  _proto.render = function render() {
    var _this2 = this;
    return /*#__PURE__*/React.createElement("div", {
      className: "" + styles$c.menuWrapper
    }, /*#__PURE__*/React.createElement("div", {
      className: styles$c.tabWrapper + " " + this.props.className
    }, this.props.categories.map(function (category, index) {
      return !category.hidden ? /*#__PURE__*/React.createElement(Tab, {
        key: index,
        isActive: _this2.state.activeTab === index,
        onClick: function onClick() {
          return _this2.toggleTab(index, category.name);
        },
        isAdmin: _this2.props.isAdmin,
        category: category,
        onCategoryDelete: function onCategoryDelete() {
          return _this2.props.onCategoryDelete(category.name);
        }
      }) : /*#__PURE__*/React.createElement("div", null);
    })), /*#__PURE__*/React.createElement("div", {
      className: styles$c.line
    }));
  };
  return TabMenu;
}(Component);

var styles$d = {"page":"_13LLX","logo":"_VfUgq","text":"_2deqE"};

var NotificationPage = /*#__PURE__*/function (_React$Component) {
  _inheritsLoose(NotificationPage, _React$Component);
  function NotificationPage() {
    return _React$Component.apply(this, arguments) || this;
  }
  var _proto = NotificationPage.prototype;
  _proto.render = function render() {
    return /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement(Container, {
      className: styles$d.page
    }, /*#__PURE__*/React.createElement("img", {
      className: styles$d.logo,
      src: this.props.logo,
      alt: "Logo"
    }), /*#__PURE__*/React.createElement("h1", null, "Oooops,"), /*#__PURE__*/React.createElement("h2", null, this.props.header), /*#__PURE__*/React.createElement("br", null), /*#__PURE__*/React.createElement("br", null), /*#__PURE__*/React.createElement(Container, {
      className: styles$d.text
    }, this.props.text)));
  };
  return NotificationPage;
}(React.Component);

var IEnotSupported = /*#__PURE__*/function (_Component) {
  _inheritsLoose(IEnotSupported, _Component);
  function IEnotSupported() {
    return _Component.apply(this, arguments) || this;
  }
  var _proto = IEnotSupported.prototype;
  _proto.render = function render() {
    return /*#__PURE__*/React.createElement(NotificationPage, {
      header: "Internet Explorer is not supported for this page.",
      logo: this.props.logo,
      text: /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement("h4", {
        style: {
          color: '#cf8d36'
        }
      }, " How to change your default browser "), /*#__PURE__*/React.createElement("p", {
        style: {
          color: '#354442'
        }
      }, /*#__PURE__*/React.createElement("strong", null, " Did you click on a link and Internet Explorer was the browser that opened it?", /*#__PURE__*/React.createElement("br", null), "You need to change your default browser!")), /*#__PURE__*/React.createElement("br", null), /*#__PURE__*/React.createElement("ol", {
        style: {
          textAlign: 'left',
          display: 'inline-block'
        }
      }, /*#__PURE__*/React.createElement("li", null, "On your computer, click the start menu"), /*#__PURE__*/React.createElement("li", null, "Click Settings"), /*#__PURE__*/React.createElement("li", null, "Click on Apps and then Default Apps"), /*#__PURE__*/React.createElement("li", null, "At the bottom, under \"Web browser\", click your current browser (Internet Explorer)"), /*#__PURE__*/React.createElement("li", null, "In the \"Choose an app\" window, select one of the following: Edge, Chrome, Firefox")))
    });
  };
  return IEnotSupported;
}(Component);

var NotFoundPage = /*#__PURE__*/function (_React$Component) {
  _inheritsLoose(NotFoundPage, _React$Component);
  function NotFoundPage() {
    return _React$Component.apply(this, arguments) || this;
  }
  var _proto = NotFoundPage.prototype;
  _proto.render = function render() {
    return /*#__PURE__*/React.createElement(NotificationPage, {
      header: "Page could not be found.",
      logo: this.props.logo,
      text: /*#__PURE__*/React.createElement("p", null, /*#__PURE__*/React.createElement("strong", null, "Please use the navigation bar on the top of the page to navigate the website. ", /*#__PURE__*/React.createElement("br", null), "If you received this error after using the navigation bar, please submit an IT Service Request ticket to report the issue.  "))
    });
  };
  return NotFoundPage;
}(React.Component);

var SearchInput = /*#__PURE__*/function (_Component) {
  _inheritsLoose(SearchInput, _Component);
  function SearchInput() {
    var _this;
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = _Component.call.apply(_Component, [this].concat(args)) || this;
    _this.keyDown = function (e) {
      if (e.key === 'Enter') _this.props.onSearch(e);
    };
    return _this;
  }
  var _proto = SearchInput.prototype;
  _proto.render = function render() {
    return /*#__PURE__*/React.createElement("fieldset", {
      className: styles$6.searchWrapper
    }, /*#__PURE__*/React.createElement(TextInput$1, {
      ref: this.props.innerRef,
      className: styles$6.searchInput,
      placeholder: "Search...",
      onChange: this.props.onChange,
      onKeyDown: this.keyDown
    }), /*#__PURE__*/React.createElement(Button, {
      className: styles$6.searchButton,
      onClick: this.props.onSearch,
      title: "Search"
    }, /*#__PURE__*/React.createElement(FaSearch, null)));
  };
  return SearchInput;
}(Component);
var SearchInput$1 = React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SearchInput, _extends({}, props, {
    innerRef: ref
  }));
});

var styles$e = {"wrapper":"_2Ngks","filterRow":"_2IA_5","searchButtons":"_2_Gb_","logEntryHeader":"_3Z-Ny","selectedRow":"_1s3Uq","normalRow":"_3C6Ge","row":"_1EcqY","created":"_25hM9","user":"_13fXn","pageProcedure":"_3Th9d","page":"_2yTaH","message":"_hguVr","severity":"_3u2if","pageButtons":"_T-yNn","logMessage":"_1098I"};

var styles$f = {"spinnerWrapper":"_SxUd-"};

function Spinner(props) {
  return /*#__PURE__*/React.createElement("div", {
    className: styles$f.spinnerWrapper
  }, /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement(TailSpin, {
    heigth: "50",
    width: "50",
    color: "#d59038",
    arialLabel: props.message
  })), /*#__PURE__*/React.createElement("p", null, props.message));
}

var LogGrid = /*#__PURE__*/function (_Component) {
  _inheritsLoose(LogGrid, _Component);
  function LogGrid(props) {
    var _this;
    _this = _Component.call(this, props) || this;
    _this.showLogEntry = function (e) {
      _this.setState({
        logEntry: _this.state.logEntries.find(function (l) {
          return l.logId.toString() === e.currentTarget.id;
        }),
        selectedId: e.currentTarget.id
      });
    };
    _this.showdataRecord = function (e) {
      _this.setState({
        selectedId: e.currentTarget.id
      });
    };
    _this.onSelectPositions = function (e) {
      var selectedUsers = [];
      if (e.length > 0) {
        selectedUsers.push(e.map(function (x) {
          return x.value;
        }));
      }
      _this.setState({
        selectedUsers: selectedUsers
      });
    };
    _this.formatMessage = function (val, maxLength, isDate) {
      var message = val.toString();
      if (isDate) {
        return new Date(message).toLocaleDateString() + '\t ' + new Date(message).toLocaleTimeString();
      } else {
        message = _this.replaceAll(message, 'http://localhost:5918', '');
        message = _this.replaceAll(message, 'http://localhost:5900', '');
        message = _this.replaceAll(message, 'http://localhost:5000', '');
        message = _this.replaceAll(message, 'https://mimg.us', '');
      }
      if (maxLength === 0) {
        return message;
      } else {
        return message.substr(0, maxLength);
      }
    };
    _this.searchByKeywords = function (e) {
      _this.setState({
        loading: true
      });
      var l_selectedUsers = [];
      for (var i in _this.state.selectedUsers[0]) {
        l_selectedUsers.push(_this.state.selectedUsers[0][i]);
      }
      var keyWords = document.getElementById('txtKeywordSearch').value;
      var searchObj = {
        keywords: keyWords && keyWords.split(','),
        userIds: _this.props.selectedUsers ? _this.props.selectedUsers : l_selectedUsers.length > 0 ? l_selectedUsers : null,
        from: document.getElementById('datePickerFrom').value,
        to: document.getElementById('datePickerTo').value,
        severity: document.getElementById('ddlSeverity').value,
        pageName: document.getElementById('txtPageName').value,
        pageSize: _this.pageSize,
        page: _this.state.page
      };
      var queryParams = Object.keys(searchObj).map(function (key) {
        return searchObj[key] && key + '=' + searchObj[key];
      }).join('&');
      axios$1.get("api/log/getLogs?" + queryParams).then(function (response) {
        var le = response.data.logs;
        for (var i in le) {
          le[i].message = _this.replaceAll(le[i].message, ' at ', '<br />&emsp;at ');
        }
        var pageCount = Math.ceil(Number(response.data.count) / _this.pageSize);
        _this.setState({
          logEntries: le,
          keyWords: keyWords,
          recordCount: response.data.count,
          page: _this.state.page,
          pageCount: pageCount,
          loading: false
        });
      });
    };
    _this.clear = function () {
      document.getElementById('txtKeywordSearch').value = '';
      document.getElementById('ddlSeverity').selectedIndex = 0;
      document.getElementById('txtPageName').value = '';
      _this.setState({
        keyWords: '',
        logEntries: [],
        pageName: '',
        beginDate: _this.defaultStartDate,
        endDate: _this.defaultEndDate
      });
      _this.forceUpdate();
    };
    _this.escapeRegExp = function (string) {
      return string.replace(/[.*+?^${}()|[\]\\]/g, '\\$&');
    };
    _this.replaceAll = function (str, find, replace) {
      return str.replace(new RegExp(_this.escapeRegExp(find), 'g'), replace);
    };
    _this.onSubmit = function (e) {
      e.preventDefault();
      _this.setState({
        page: 1
      }, function () {
        return _this.searchByKeywords();
      });
    };
    var dt = new Date();
    _this.defaultEndDate = dt.toISOString().substring(0, 10);
    dt.setDate(dt.getDate() - 1);
    _this.defaultStartDate = dt.toISOString().substring(0, 10);
    _this.state = {
      recordCount: 0,
      page: 1,
      pageCount: 1,
      logEntries: [],
      keyWords: '',
      selectedUsers: _this.props.selectedUsers ? _this.props.selectedUsers.map(function (e) {
        return e.value;
      }) : [],
      beginDate: _this.defaultStartDate,
      endDate: _this.defaultEndDate
    };
    _this.pageSize = 10;
    return _this;
  }
  var _proto = LogGrid.prototype;
  _proto.onPageClick = function onPageClick(e, iPageDirection) {
    var _this2 = this;
    if (this.state.loading) return;
    var newPageNum = 0;
    switch (iPageDirection) {
      case 0:
        newPageNum = 1;
        break;
      case 1:
        if (this.state.page > 0) newPageNum = this.state.page - 1;
        break;
      case 2:
        if (this.state.page < this.state.pageCount) newPageNum = this.state.page + 1;
        break;
      case 3:
        newPageNum = Math.ceil(this.state.recordCount / this.pageSize);
        break;
    }
    this.setState({
      page: newPageNum
    }, function () {
      return _this2.searchByKeywords();
    });
    return 1;
  };
  _proto.getDate = function getDate(dateString) {
    return new Date(dateString).toLocaleDateString('en-US', {
      year: 'numeric',
      month: 'long',
      day: 'numeric'
    });
  };
  _proto.getTime = function getTime(dateString) {
    return new Date(dateString).toLocaleTimeString('en-US');
  };
  _proto.render = function render() {
    var _this3 = this;
    return /*#__PURE__*/React.createElement("div", {
      className: styles$e.wrapper
    }, /*#__PURE__*/React.createElement(Form, {
      id: "GridForm",
      onSubmit: this.onSubmit
    }, /*#__PURE__*/React.createElement("div", {
      className: styles$e.filterRow
    }, /*#__PURE__*/React.createElement(FormGroup, null, /*#__PURE__*/React.createElement(Label, {
      "for": "txtKeywordSearch"
    }, "Keywords:"), /*#__PURE__*/React.createElement(Input, {
      type: "text",
      id: "txtKeywordSearch",
      defaultValue: this.state.keyWords
    })), /*#__PURE__*/React.createElement(FormGroup, null, /*#__PURE__*/React.createElement(Label, {
      "for": "txtPageName"
    }, "Page:"), /*#__PURE__*/React.createElement(Input, {
      type: "text",
      id: "txtPageName",
      defaultValue: this.state.pageName
    }))), /*#__PURE__*/React.createElement("div", {
      className: styles$e.filterRow
    }, /*#__PURE__*/React.createElement(FormGroup, null, /*#__PURE__*/React.createElement(Label, {
      "for": "datePickerFrom"
    }, "From"), /*#__PURE__*/React.createElement(Input, {
      id: "datePickerFrom",
      name: "datePickerFrom",
      type: "date",
      defaultValue: this.state.beginDate
    })), /*#__PURE__*/React.createElement(FormGroup, null, /*#__PURE__*/React.createElement(Label, {
      "for": "datePickerTo"
    }, "To"), /*#__PURE__*/React.createElement(Input, {
      id: "datePickerTo",
      name: "datePickerTo",
      type: "date",
      defaultValue: this.state.endDate
    })), /*#__PURE__*/React.createElement(FormGroup, null, /*#__PURE__*/React.createElement(Label, {
      "for": "ddlUser"
    }, "User:"), /*#__PURE__*/React.createElement(Select, {
      type: "select",
      id: "ddlUser",
      isMulti: true,
      closeMenuOnSelect: false,
      options: this.props.userList,
      defaultValue: this.props.populateFirstUser ? this.props.userList[0] : null,
      onChange: this.onSelectPositions,
      placeholder: "Select a User or Users to Filter By"
    })), /*#__PURE__*/React.createElement(FormGroup, null, /*#__PURE__*/React.createElement(Label, {
      "for": "ddlSeverity"
    }, "Severity:"), /*#__PURE__*/React.createElement(Input, {
      type: "select",
      id: "ddlSeverity"
    }, /*#__PURE__*/React.createElement("option", {
      value: ""
    }), /*#__PURE__*/React.createElement("option", {
      value: "0"
    }, "0"), /*#__PURE__*/React.createElement("option", {
      value: "1"
    }, "1"), /*#__PURE__*/React.createElement("option", {
      value: "2"
    }, "2"), /*#__PURE__*/React.createElement("option", {
      value: "3"
    }, "3")))), /*#__PURE__*/React.createElement("div", {
      className: styles$e.searchButtons
    }, /*#__PURE__*/React.createElement(Button$2, {
      type: "submit"
    }, "Search"), /*#__PURE__*/React.createElement(Button$2, {
      onClick: function onClick(event) {
        return _this3.clear(event, _this3);
      }
    }, "Reset"))), this.state.loading ? /*#__PURE__*/React.createElement(Spinner, {
      message: "Loading Logs"
    }) : this.state.logEntries && this.state.logEntries.length > 0 && /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement("div", {
      className: styles$e.logEntryHeader
    }, /*#__PURE__*/React.createElement("div", {
      className: styles$e.row
    }, /*#__PURE__*/React.createElement("div", {
      className: styles$e.created
    }, "Created"), this.props.userList.length > 1 && /*#__PURE__*/React.createElement("div", {
      className: styles$e.user
    }, "User"), /*#__PURE__*/React.createElement("div", {
      className: styles$e.pageProcedure
    }, "Action/Page"), /*#__PURE__*/React.createElement("div", {
      className: styles$e.message
    }, "Message"), /*#__PURE__*/React.createElement("div", {
      className: styles$e.severity
    }, "Sev."))), this.state.logEntries.map(function (record) {
      return /*#__PURE__*/React.createElement("div", {
        onClick: _this3.showLogEntry,
        className: _this3.state.selectedId === record.logId.toString() ? styles$e.selectedRow : styles$e.normalRow,
        id: record.logId,
        key: record.logId
      }, /*#__PURE__*/React.createElement("div", {
        className: styles$e.row
      }, /*#__PURE__*/React.createElement("div", {
        className: styles$e.created
      }, /*#__PURE__*/React.createElement("div", null, _this3.getTime(record.createDateTime), "\xA0"), /*#__PURE__*/React.createElement("div", null, _this3.getDate(record.createDateTime))), _this3.props.userList.length > 1 && /*#__PURE__*/React.createElement("div", {
        className: styles$e.user
      }, record.userName), /*#__PURE__*/React.createElement("div", {
        className: styles$e.pageProcedure
      }, /*#__PURE__*/React.createElement("div", null, record.procedureName), /*#__PURE__*/React.createElement("div", {
        className: styles$e.page
      }, " ", _this3.formatMessage(record.pageName, 0))), /*#__PURE__*/React.createElement("div", {
        className: styles$e.message
      }, _this3.formatMessage(record.message, 50)), /*#__PURE__*/React.createElement("div", {
        className: styles$e.severity
      }, record.severity)));
    })), /*#__PURE__*/React.createElement("div", null, "Page: ", this.state.page, " of ", Math.max(parseInt(this.state.pageCount), 1), " (", this.state.recordCount, " records found.)"), /*#__PURE__*/React.createElement("div", {
      className: styles$e.pageButtons
    }, /*#__PURE__*/React.createElement(Button$2, {
      onClick: function onClick(e) {
        return _this3.onPageClick(e, 0);
      },
      className: styles$e.wide
    }, "<<"), /*#__PURE__*/React.createElement(Button$2, {
      onClick: function onClick(e) {
        return _this3.onPageClick(e, 1);
      },
      className: styles$e.wide
    }, "<"), /*#__PURE__*/React.createElement(Button$2, {
      onClick: function onClick(e) {
        return _this3.onPageClick(e, 2);
      },
      className: styles$e.wide
    }, ">"), /*#__PURE__*/React.createElement(Button$2, {
      onClick: function onClick(e) {
        return _this3.onPageClick(e, 3);
      },
      className: styles$e.wide
    }, ">>"))), this.state.logEntries && this.state.logEntries.length === 0 && this.state.keyWords && /*#__PURE__*/React.createElement("span", null, /*#__PURE__*/React.createElement("br", null), /*#__PURE__*/React.createElement("br", null), "No Logs Found"), this.state.logEntry && /*#__PURE__*/React.createElement("span", null, /*#__PURE__*/React.createElement("br", null), /*#__PURE__*/React.createElement("br", null), /*#__PURE__*/React.createElement("hr", null), "Log ID: ", /*#__PURE__*/React.createElement("span", null, this.state.logEntry.logId), /*#__PURE__*/React.createElement("br", null), "Date: ", /*#__PURE__*/React.createElement("span", null, new Date(this.state.logEntry.createDateTime).toLocaleDateString() + ' ' + new Date(this.state.logEntry.createDateTime).toLocaleTimeString()), "\xA0\xA0\xA0\xA0 Page: ", /*#__PURE__*/React.createElement("span", null, /*#__PURE__*/React.createElement("a", {
      href: this.state.logEntry.pageName,
      target: "_blank",
      rel: "noreferrer"
    }, this.state.logEntry.pageName)), /*#__PURE__*/React.createElement("br", null), "User: ", /*#__PURE__*/React.createElement("span", null, this.state.logEntry.userName), /*#__PURE__*/React.createElement("br", null), "Prop ID: ", /*#__PURE__*/React.createElement("span", null, this.state.logEntry.propertyID), /*#__PURE__*/React.createElement("br", null), "Proc: ", /*#__PURE__*/React.createElement("span", null, this.state.logEntry.procedureName), /*#__PURE__*/React.createElement("br", null), /*#__PURE__*/React.createElement("div", {
      className: this.state.selectedId ? styles$e.logMessage : ""
    }, parse(this.state.logEntry.message))));
  };
  return LogGrid;
}(Component);

var styles$g = {"dataRow":"_3Caqq","dataDisplay":"_3Veja","mimgPadAll10":"_1k0mF","panel":"_2bRbU","listBox":"_kjfpm","header":"_FHLQQ","columnHeader1":"_2NfiG","columnHeader2":"_i-kZ_","columnHeader3":"_29T0M","columnHeader4":"_uSDoe","columnHeader5":"_3Q3Si","column1":"_Y8JP8","column2":"_1hvs2","column3":"_YSuOr","column4":"_3mYSd","column5":"_UTp20","padRight":"_33Kkn","linkText":"_1ZgwD","linkTextStrikethrough":"_1FGvB","well":"_1wLpV","ckEditor":"_3YGva","marginTop10":"_HtPvB","yesNoDropdown":"_jbs7F","flexRow":"_1yQmL","flexAlignEnd":"_37Y0h","paddingTop10":"_2vtW6","boldUnderline":"_3OXG6","cardWrapper":"_oePOv","icon":"_3BJ8-","cardInfoWrapper":"_2fQjy"};

var GenericEmailHistoryForm = /*#__PURE__*/function (_Component) {
  _inheritsLoose(GenericEmailHistoryForm, _Component);
  function GenericEmailHistoryForm(props) {
    var _this;
    _this = _Component.call(this, props) || this;
    _this.reset = function () {
      _this.setState({
        selectedEmail: null
      });
    };
    _this.state = {
      selectedEmail: null
    };
    _this.loadEmail = _this.loadEmail.bind(_assertThisInitialized(_this));
    _this.reset = _this.reset.bind(_assertThisInitialized(_this));
    return _this;
  }
  var _proto = GenericEmailHistoryForm.prototype;
  _proto.loadEmail = function loadEmail(el) {
    var id = parseInt(el.currentTarget.id);
    var email = this.props.emails.filter(function (e) {
      return e.id === id;
    })[0];
    this.setState({
      selectedEmail: email
    });
  };
  _proto.render = function render() {
    var _this2 = this;
    return /*#__PURE__*/React.createElement(Fragment, null, /*#__PURE__*/React.createElement(Modal, {
      isOpen: this.props.visible,
      toggle: this.props.toggle,
      size: "lg",
      onClosed: this.reset,
      className: styles$g.padRight
    }, /*#__PURE__*/React.createElement(FormGroup, {
      className: "col"
    }, /*#__PURE__*/React.createElement(Form, null, /*#__PURE__*/React.createElement(ModalHeader, {
      toggle: this.props.toggle
    }, /*#__PURE__*/React.createElement(ModalTitle, null, this.props.title)), null != this.props.PageAlert && this.props.PageAlert.AlertText !== "" && /*#__PURE__*/React.createElement(MimgAlert, {
      alertTypeClass: "pageAlert",
      alertInfo: this.props.PageAlert,
      onDismiss: this.props.ResetModal
    }), /*#__PURE__*/React.createElement(FormGroup, {
      className: styles$g.mimgPadAll10
    }, /*#__PURE__*/React.createElement("div", {
      className: styles$g.panel
    }, /*#__PURE__*/React.createElement(Row, {
      className: styles$g.boldUnderline
    }, /*#__PURE__*/React.createElement(Col, {
      className: styles$g.columnHeader1
    }, "Id"), /*#__PURE__*/React.createElement(Col, {
      className: styles$g.columnHeader2
    }, "Date"), /*#__PURE__*/React.createElement(Col, {
      className: styles$g.columnHeader5
    }, "Email Subject")), /*#__PURE__*/React.createElement("div", {
      className: styles$g.listBox
    }, this.props.emails && this.props.emails.map(function (e) {
      return /*#__PURE__*/React.createElement(Row, {
        key: e.id
      }, /*#__PURE__*/React.createElement(Col, {
        className: styles$g.column1
      }, e.id), /*#__PURE__*/React.createElement(Col, {
        className: styles$g.column2
      }, new Date(e.sentDateTime).toLocaleDateString() + ' ' + new Date(e.sentDateTime).toLocaleTimeString()), /*#__PURE__*/React.createElement(Col, {
        className: styles$g.column5 + " " + styles$g.linkText,
        id: e.id,
        onClick: _this2.loadEmail
      }, e.emailSubject));
    }))), null != this.state.selectedEmail && /*#__PURE__*/React.createElement(Fragment, null, /*#__PURE__*/React.createElement(Row, {
      className: styles$g.dataRow
    }, /*#__PURE__*/React.createElement(Col, {
      md: 2
    }, "Subject"), /*#__PURE__*/React.createElement(Col, {
      className: styles$g.dataDisplay
    }, this.state.selectedEmail.emailSubject)), /*#__PURE__*/React.createElement(Row, {
      className: styles$g.dataRow
    }, /*#__PURE__*/React.createElement(Col, {
      md: 2
    }, "Date/Time"), /*#__PURE__*/React.createElement(Col, {
      className: styles$g.dataDisplay
    }, new Date(this.state.selectedEmail.createDateTime).toLocaleDateString() + ' ' + new Date(this.state.selectedEmail.createDateTime).toLocaleTimeString())), /*#__PURE__*/React.createElement(Row, {
      className: styles$g.dataRow
    }, /*#__PURE__*/React.createElement(Col, {
      md: 2
    }, "From"), /*#__PURE__*/React.createElement(Col, {
      className: styles$g.dataDisplay
    }, this.state.selectedEmail.emailFrom)), /*#__PURE__*/React.createElement(Row, {
      className: styles$g.dataRow
    }, /*#__PURE__*/React.createElement(Col, {
      md: 2
    }, "To"), /*#__PURE__*/React.createElement(Col, {
      className: styles$g.dataDisplay
    }, this.state.selectedEmail.emailTo)), /*#__PURE__*/React.createElement(Row, {
      className: styles$g.dataRow
    }, /*#__PURE__*/React.createElement(Col, {
      md: 2
    }, "CC"), /*#__PURE__*/React.createElement(Col, {
      className: styles$g.dataDisplay
    }, this.state.selectedEmail.emailCc)), /*#__PURE__*/React.createElement(Row, {
      className: styles$g.dataRow
    }, /*#__PURE__*/React.createElement(Col, {
      md: 2
    }, "BCC"), /*#__PURE__*/React.createElement(Col, {
      className: styles$g.dataDisplay
    }, this.state.selectedEmail.emailBcc)), /*#__PURE__*/React.createElement(Row, {
      className: styles$g.dataRow
    }, /*#__PURE__*/React.createElement(Col, {
      md: 2
    }, "Body"), /*#__PURE__*/React.createElement(Col, {
      className: styles$g.dataDisplay
    }, /*#__PURE__*/React.createElement("span", {
      dangerouslySetInnerHTML: {
        __html: this.state.selectedEmail.emailBody
      }
    }))))))), /*#__PURE__*/React.createElement(ModalFooter, null, /*#__PURE__*/React.createElement(Button, {
      onClick: this.props.toggle,
      transparent: true
    }, "Close"), " ", "  ")));
  };
  return GenericEmailHistoryForm;
}(Component);

var styles$h = {"flexRow":"_PsEYd","flexTitleRow":"_3Ik_P","tableHeader":"_2EYpD","flex1":"_2-Cjm","flex2AlignEnd":"_24TBU","borderAbove":"_3cmya","tableFooter":"_aPKgZ","componentPadding":"_6JZHy","keepOnSameLine":"_2EQNH","active":"_36lec"};

var AcquisitionHistoryTable = /*#__PURE__*/function (_Component) {
  _inheritsLoose(AcquisitionHistoryTable, _Component);
  function AcquisitionHistoryTable(props) {
    var _this;
    _this = _Component.call(this, props) || this;
    _this.updateAcqHistoryTable = function (e) {
      _this.setState({
        groupByWhat: e.target.id
      });
    };
    _this.getPlaceName = function (placeData) {
      var placeName;
      if (_this.props.placeData.stateName) {
        placeName = _this.props.placeData.stateName;
      } else if (_this.props.placeData.description) {
        placeName = _this.props.placeData.description;
      } else {
        placeName = "National Portfolio";
      }
      return placeName;
    };
    _this.getCurrencyFormatter = function (minDigits) {
      var formatter = new Intl.NumberFormat('en-US', {
        style: 'currency',
        currency: 'USD',
        minimumFractionDigits: minDigits ? minDigits : 0,
        maximumFractionDigits: minDigits ? minDigits : 0
      });
      return formatter;
    };
    _this.formatCurrencyForPhoneScreen = function (amt) {
      var formatter = _this.getCurrencyFormatter(1);
      amt = amt / 1000000;
      return formatter.format(amt) + 'M';
    };
    _this.getTotalsData = function (dataByYear) {
      var totalPropsAdded = 0;
      var totalPropsSold = 0;
      var totalUnitsAdded = 0;
      var totalUnitsSold = 0;
      var totalCapitalAdded = 0;
      var totalCapitalSold = 0;
      var totalPriceAdded = 0;
      var totalPriceSold = 0;
      for (var i = 0; i < dataByYear.length; i++) {
        totalPropsAdded += dataByYear[i].annualAcquisitions;
        totalPropsSold += dataByYear[i].annualSales;
        totalUnitsAdded += dataByYear[i].annualUnitsAdded;
        totalUnitsSold += dataByYear[i].annualUnitsSold;
        totalCapitalAdded += dataByYear[i].annualCapitalAdded;
        totalCapitalSold += dataByYear[i].annualCapitalSold;
        totalPriceAdded += dataByYear[i].annualPriceAdded;
        totalPriceSold += dataByYear[i].annualPriceSold;
      }
      var obj = {};
      obj.totalPropsAdded = totalPropsAdded;
      obj.totalPropsSold = totalPropsSold;
      obj.totalUnitsAdded = totalUnitsAdded;
      obj.totalUnitsSold = totalUnitsSold;
      obj.totalCapitalAdded = totalCapitalAdded;
      obj.totalCapitalSold = totalCapitalSold;
      obj.totalPriceAdded = totalPriceAdded;
      obj.totalPriceSold = totalPriceSold;
      return obj;
    };
    _this.consolidateEarlyYears = function (dataByYear) {
      var cutoffYear = _this.props.cutoffYear ? _this.props.cutoffYear : 1900;
      var consolidatedData = [];
      var minYear = dataByYear[0].yr;
      if (minYear <= 1999) {
        var earlyYears = dataByYear.filter(function (x) {
          return x.yr <= cutoffYear;
        });
        var firstItem = _this.convertToDataByYear(_this.getTotalsData(earlyYears), minYear, cutoffYear);
        consolidatedData.push(firstItem);
      }
      var laterYears = dataByYear.filter(function (x) {
        return x.yr > cutoffYear;
      });
      for (var i = 0; i < laterYears.length; i++) {
        consolidatedData.push(laterYears[i]);
      }
      return consolidatedData;
    };
    _this.convertToDataByYear = function (cd, minYear, cutoffYear) {
      var obj = {};
      obj.yr = minYear.toString().substring(2) + "-" + cutoffYear.toString().substring(2);
      obj.annualUnitsAdded = cd.totalUnitsAdded;
      obj.annualUnitsSold = cd.totalUnitsSold;
      obj.unitsAtYearEnd = cd.totalUnitsAdded - cd.totalUnitsSold;
      obj.annualAcquisitions = cd.totalPropsAdded;
      obj.annualSales = cd.totalPropsSold;
      obj.propsAtYearEnd = cd.totalPropsAdded - cd.totalPropsSold;
      obj.annualCapitalAdded = cd.totalCapitalAdded;
      obj.annualCapitalSold = cd.totalCapitalSold;
      obj.capitalAtYearEnd = cd.totalCapitalAdded - cd.totalCapitalSold;
      obj.annualPriceAdded = cd.totalPriceAdded;
      obj.annualPriceSold = cd.totalPriceSold;
      obj.priceAtYearEnd = cd.totalPriceAdded - cd.totalPriceSold;
      return obj;
    };
    _this.state = {
      groupByWhat: "btnUnits"
    };
    return _this;
  }
  var _proto = AcquisitionHistoryTable.prototype;
  _proto.componentDidMount = function componentDidMount() {};
  _proto.render = function render() {
    var _this2 = this;
    var totalsData = this.getTotalsData(this.props.placeData.dataByYear);
    var dataByYear = this.consolidateEarlyYears(this.props.placeData.dataByYear);
    var currencyFormatter = this.getCurrencyFormatter();
    return /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement("div", {
      className: "" + styles$h.flexTitleRow
    }, /*#__PURE__*/React.createElement("div", {
      className: styles$h.flex1
    }, /*#__PURE__*/React.createElement(Button, {
      id: "btnUnits",
      transparent: true,
      className: this.state.groupByWhat === "btnUnits" ? styles$h.active : styles$h.nothing,
      onClick: this.updateAcqHistoryTable
    }, "Units"), /*#__PURE__*/React.createElement(Button, {
      id: "btnProperties",
      transparent: true,
      className: this.state.groupByWhat === "btnProperties" ? styles$h.active : styles$h.nothing,
      onClick: this.updateAcqHistoryTable
    }, "Props"), /*#__PURE__*/React.createElement(Button, {
      id: "btnCapital",
      transparent: true,
      className: this.state.groupByWhat === "btnCapital" ? styles$h.active : styles$h.nothing,
      onClick: this.updateAcqHistoryTable
    }, "Capital"), /*#__PURE__*/React.createElement(Button, {
      id: "btnPrice",
      transparent: true,
      className: this.state.groupByWhat === "btnPrice" ? styles$h.active : styles$h.nothing,
      onClick: this.updateAcqHistoryTable
    }, "Acq Price"))), /*#__PURE__*/React.createElement("section", null, /*#__PURE__*/React.createElement("div", {
      className: styles$h.flexRow
    }, /*#__PURE__*/React.createElement("div", {
      className: styles$h.flex1
    }, /*#__PURE__*/React.createElement("span", {
      className: styles$h.tableHeader
    }, /*#__PURE__*/React.createElement("b", null, /*#__PURE__*/React.createElement("u", null, "Year")))), /*#__PURE__*/React.createElement("div", {
      className: "" + styles$h.flex2AlignEnd
    }, /*#__PURE__*/React.createElement("span", {
      className: styles$h.tableHeader + " " + styles$h.keepOnSameLine
    }, /*#__PURE__*/React.createElement("b", null, /*#__PURE__*/React.createElement("u", null, "Bought")))), /*#__PURE__*/React.createElement("div", {
      className: "" + styles$h.flex2AlignEnd
    }, /*#__PURE__*/React.createElement("span", {
      className: styles$h.tableHeader + " " + styles$h.keepOnSameLine
    }, /*#__PURE__*/React.createElement("b", null, /*#__PURE__*/React.createElement("u", null, "Sold")))), /*#__PURE__*/React.createElement("div", {
      className: "" + styles$h.flex2AlignEnd
    }, /*#__PURE__*/React.createElement("span", {
      className: styles$h.tableHeader + " " + styles$h.keepOnSameLine
    }, /*#__PURE__*/React.createElement("b", null, /*#__PURE__*/React.createElement("u", null, "Year End"))))), this.state.groupByWhat === "btnUnits" ? /*#__PURE__*/React.createElement(Fragment, null, dataByYear.map(function (p) {
      return (p.annualAcquisitions > 0 || p.annualSales > 0) && /*#__PURE__*/React.createElement("div", {
        key: p.yr,
        className: styles$h.flexRow
      }, /*#__PURE__*/React.createElement("div", {
        className: styles$h.flex1
      }, p.yr), /*#__PURE__*/React.createElement("div", {
        className: styles$h.flex2AlignEnd + " " + styles$h.keepOnSameLine
      }, p.annualUnitsAdded.toLocaleString(), " "), /*#__PURE__*/React.createElement("div", {
        className: styles$h.flex2AlignEnd + " " + styles$h.keepOnSameLine
      }, p.annualUnitsSold.toLocaleString()), /*#__PURE__*/React.createElement("div", {
        className: styles$h.flex2AlignEnd + " " + styles$h.keepOnSameLine
      }, p.unitsAtYearEnd.toLocaleString()));
    }), /*#__PURE__*/React.createElement("div", {
      className: styles$h.flexRow + " " + styles$h.borderAbove
    }, /*#__PURE__*/React.createElement("div", {
      className: styles$h.flex1 + " " + styles$h.tableFooter + " " + styles$h.keepOnSameLine
    }, "Totals"), /*#__PURE__*/React.createElement("div", {
      className: styles$h.flex2AlignEnd + " " + styles$h.tableFooter + " " + styles$h.keepOnSameLine
    }, totalsData.totalUnitsAdded.toLocaleString(), " "), /*#__PURE__*/React.createElement("div", {
      className: styles$h.flex2AlignEnd + " " + styles$h.tableFooter + " " + styles$h.keepOnSameLine
    }, totalsData.totalUnitsSold.toLocaleString()), /*#__PURE__*/React.createElement("div", {
      className: styles$h.flex2AlignEnd + " " + styles$h.tableFooter + " " + styles$h.keepOnSameLine
    }, (totalsData.totalUnitsAdded - totalsData.totalUnitsSold).toLocaleString(), /*#__PURE__*/React.createElement("br", null), "^Current^"))) : /*#__PURE__*/React.createElement(Fragment, null), this.state.groupByWhat === "btnProperties" ? /*#__PURE__*/React.createElement(Fragment, null, dataByYear.map(function (p) {
      return (p.annualAcquisitions > 0 || p.annualSales > 0) && /*#__PURE__*/React.createElement("div", {
        key: p.yr,
        className: styles$h.flexRow
      }, /*#__PURE__*/React.createElement("div", {
        className: styles$h.flex1
      }, p.yr), /*#__PURE__*/React.createElement("div", {
        className: styles$h.flex2AlignEnd + " " + styles$h.keepOnSameLine
      }, p.annualAcquisitions, " "), /*#__PURE__*/React.createElement("div", {
        className: styles$h.flex2AlignEnd + " " + styles$h.keepOnSameLine
      }, p.annualSales), /*#__PURE__*/React.createElement("div", {
        className: styles$h.flex2AlignEnd + " " + styles$h.keepOnSameLine
      }, p.propsAtYearEnd));
    }), /*#__PURE__*/React.createElement("div", {
      className: styles$h.flexRow + " " + styles$h.borderAbove
    }, /*#__PURE__*/React.createElement("div", {
      className: styles$h.flex1 + " " + styles$h.tableFooter + " " + styles$h.keepOnSameLine
    }, "Totals"), /*#__PURE__*/React.createElement("div", {
      className: styles$h.flex2AlignEnd + " " + styles$h.tableFooter + " " + styles$h.keepOnSameLine
    }, totalsData.totalPropsAdded.toLocaleString(), " "), /*#__PURE__*/React.createElement("div", {
      className: styles$h.flex2AlignEnd + " " + styles$h.tableFooter + " " + styles$h.keepOnSameLine
    }, totalsData.totalPropsSold.toLocaleString()), /*#__PURE__*/React.createElement("div", {
      className: styles$h.flex2AlignEnd + " " + styles$h.tableFooter + " " + styles$h.keepOnSameLine
    }, (totalsData.totalPropsAdded - totalsData.totalPropsSold).toLocaleString(), /*#__PURE__*/React.createElement("br", null), "^Current^"))) : /*#__PURE__*/React.createElement(Fragment, null), this.state.groupByWhat === "btnCapital" ? /*#__PURE__*/React.createElement(Fragment, null, dataByYear.map(function (p) {
      return (p.annualAcquisitions > 0 || p.annualSales > 0) && /*#__PURE__*/React.createElement("div", {
        key: p.yr,
        className: styles$h.flexRow
      }, /*#__PURE__*/React.createElement("div", {
        className: styles$h.flex1
      }, p.yr), /*#__PURE__*/React.createElement("div", {
        className: styles$h.flex2AlignEnd + " " + styles$h.keepOnSameLine + " d-block"
      }, _this2.formatCurrencyForPhoneScreen(p.annualCapitalAdded), " "), /*#__PURE__*/React.createElement("div", {
        className: styles$h.flex2AlignEnd + " " + styles$h.keepOnSameLine + " d-block"
      }, _this2.formatCurrencyForPhoneScreen(p.annualCapitalSold)), /*#__PURE__*/React.createElement("div", {
        className: styles$h.flex2AlignEnd + " " + styles$h.keepOnSameLine + " d-block"
      }, _this2.formatCurrencyForPhoneScreen(p.capitalAtYearEnd)));
    }), /*#__PURE__*/React.createElement("div", {
      className: styles$h.flexRow + " " + styles$h.borderAbove
    }, /*#__PURE__*/React.createElement("div", {
      className: styles$h.flex1 + " " + styles$h.tableFooter + " " + styles$h.keepOnSameLine
    }, "Totals"), /*#__PURE__*/React.createElement("div", {
      className: styles$h.flex2AlignEnd + " " + styles$h.tableFooter + " " + styles$h.keepOnSameLine + " d-block"
    }, this.formatCurrencyForPhoneScreen(totalsData.totalCapitalAdded), " "), /*#__PURE__*/React.createElement("div", {
      className: styles$h.flex2AlignEnd + " " + styles$h.tableFooter + " " + styles$h.keepOnSameLine + " d-block"
    }, this.formatCurrencyForPhoneScreen(totalsData.totalCapitalSold)), /*#__PURE__*/React.createElement("div", {
      className: styles$h.flex2AlignEnd + " " + styles$h.tableFooter + " " + styles$h.keepOnSameLine + " d-block"
    }, this.formatCurrencyForPhoneScreen(totalsData.totalCapitalAdded - totalsData.totalCapitalSold), /*#__PURE__*/React.createElement("br", null), "^Current^"))) : /*#__PURE__*/React.createElement(Fragment, null), this.state.groupByWhat === "btnPrice" ? /*#__PURE__*/React.createElement(Fragment, null, dataByYear.map(function (p) {
      return (p.annualAcquisitions > 0 || p.annualSales > 0) && /*#__PURE__*/React.createElement("div", {
        key: p.yr,
        className: styles$h.flexRow
      }, /*#__PURE__*/React.createElement("div", {
        className: styles$h.flex1
      }, p.yr), /*#__PURE__*/React.createElement("div", {
        className: styles$h.flex2AlignEnd + " " + styles$h.keepOnSameLine + " d-block"
      }, _this2.formatCurrencyForPhoneScreen(p.annualPriceAdded), " "), /*#__PURE__*/React.createElement("div", {
        className: styles$h.flex2AlignEnd + " " + styles$h.keepOnSameLine + " d-block"
      }, _this2.formatCurrencyForPhoneScreen(p.annualPriceSold)), /*#__PURE__*/React.createElement("div", {
        className: styles$h.flex2AlignEnd + " " + styles$h.keepOnSameLine + " d-block"
      }, _this2.formatCurrencyForPhoneScreen(p.priceAtYearEnd)));
    }), /*#__PURE__*/React.createElement("div", {
      className: styles$h.flexRow + " " + styles$h.borderAbove
    }, /*#__PURE__*/React.createElement("div", {
      className: styles$h.flex1 + " " + styles$h.tableFooter + " " + styles$h.keepOnSameLine
    }, "Totals"), /*#__PURE__*/React.createElement("div", {
      className: styles$h.flex2AlignEnd + " " + styles$h.tableFooter + " " + styles$h.keepOnSameLine + " d-block"
    }, this.formatCurrencyForPhoneScreen(totalsData.totalPriceAdded), " "), /*#__PURE__*/React.createElement("div", {
      className: styles$h.flex2AlignEnd + " " + styles$h.tableFooter + " " + styles$h.keepOnSameLine + " d-block"
    }, this.formatCurrencyForPhoneScreen(totalsData.totalPriceSold)), /*#__PURE__*/React.createElement("div", {
      className: styles$h.flex2AlignEnd + " " + styles$h.tableFooter + " " + styles$h.keepOnSameLine + " d-block"
    }, this.formatCurrencyForPhoneScreen(totalsData.totalPriceAdded - totalsData.totalPriceSold), /*#__PURE__*/React.createElement("br", null), "^Current^"))) : /*#__PURE__*/React.createElement(Fragment, null)));
  };
  return AcquisitionHistoryTable;
}(Component);

var styles$i = {"flexRow":"_1qqbu","dropdown":"_2neEe","centeredTitle":"_1H4rw"};

var MapChart = /*#__PURE__*/function (_Component) {
  _inheritsLoose(MapChart, _Component);
  function MapChart(props) {
    var _this;
    _this = _Component.call(this, props) || this;
    _this.toggleTooltip = function () {
      _this.setState({
        tooltipOpen: !_this.state.tooltipOpen
      });
    };
    _this.getOption = function (id, value) {
      var obj = {};
      obj.id = id;
      obj.value = value;
      console.log({
        obj: obj
      });
      return obj;
    };
    _this.handleGroupTypeChange = function (event) {
      var groupingType = event.target.selectedOptions[0].id;
      var groupingMembers = [];
      var groupValue = "";
      switch (groupingType) {
        case "groupByNational":
          _this.props.onResetToNational();
          break;
        case "groupByState":
          _this.props.stateMapData.stateData.map(function (s) {
            groupingMembers.push(_this.getOption(s.stateAbbr, s.stateName));
          });
          groupValue = "state";
          break;
        case "groupByRegion":
          _this.props.stateMapData.cityMetroData.sort().map(function (s) {
            groupingMembers.push(_this.getOption(s.mapGroupId, s.description));
          });
          groupValue = "region/metro";
          break;
      }
      _this.setState({
        groupingType: groupingType,
        groupingMembers: groupingMembers,
        groupValue: groupValue
      });
    };
    _this.handleGroupingValueChange = function (event) {
      var selected = event.target.selectedOptions[0];
      console.log({
        selected: selected
      });
      switch (_this.state.groupingType) {
        case "groupByNational":
          break;
        case "groupByState":
          var st = _this.props.stateMapData.stateData.filter(function (x) {
            return x.stateName === selected.value;
          })[0];
          _this.props.onClickOnState(st.stateAbbr, st.stateName);
          break;
        case "groupByRegion":
          var cma = _this.props.stateMapData.cityMetroData.filter(function (x) {
            return x.description === selected.value;
          })[0];
          _this.props.onClickOnMetro(cma.mapGroupId, cma.description);
          break;
      }
    };
    _this.state = {
      tooltipContent: "",
      tooltipTarget: "",
      groupingType: "groupByNational",
      groupingMembers: []
    };
    return _this;
  }
  var _proto = MapChart.prototype;
  _proto.setTooltipContent = function setTooltipContent(id, state) {
    this.setState({
      tooltipContent: state,
      tooltipTarget: id
    });
  };
  _proto.render = function render() {
    var _this2 = this;
    var asOfYear = this.props.asOfYear ? this.props.asOfYear : new Date().getFullYear();
    return /*#__PURE__*/React.createElement(Fragment, null, /*#__PURE__*/React.createElement("div", {
      className: "d-none d-sm-block"
    }, " ", this.props.mapTitle && /*#__PURE__*/React.createElement("div", {
      className: styles$i.centeredTitle
    }, " ", /*#__PURE__*/React.createElement("h1", null, this.props.mapTitle)), /*#__PURE__*/React.createElement(ComposableMap, {
      viewBox: "0 50 800 600",
      projection: "geoAlbersUsa"
    }, /*#__PURE__*/React.createElement(Geographies, {
      geography: this.props.geography
    }, function (_ref) {
      var geographies = _ref.geographies;
      return geographies.filter(function (x) {
        return x.properties.name !== "Hawaii" && x.properties.name !== "Alaska";
      }).map(function (geo) {
        return /*#__PURE__*/React.createElement(Fragment, {
          key: geo.rsmKey
        }, _this2.props.stateMapData.stateData.filter(function (x) {
          return x.firstYearActive <= asOfYear && x.lastYearActive >= asOfYear;
        }).map(function (x) {
          return x.stateName;
        }).includes(geo.properties.name) ? /*#__PURE__*/React.createElement(Geography, {
          id: "state_" + geo.rsmKey,
          key: geo.rsmKey,
          geography: geo,
          fill: "#cf8d36",
          onClick: function onClick() {
            _this2.props.onClickOnState(geo.rsmKey, geo.properties.name);
          },
          style: {
            "default": {
              fill: "#cf8d36",
              stroke: "#607D8B",
              strokeWidth: 0.75,
              outline: "none"
            },
            hover: {
              fill: "#cf8d36",
              stroke: "#607D8B",
              strokeWidth: 3,
              outline: "none"
            },
            pressed: {
              fill: "#696a6a",
              stroke: "#607D8B",
              strokeWidth: 1,
              outline: "none"
            }
          }
        }) : /*#__PURE__*/React.createElement(Geography, {
          id: geo.rsmKey,
          key: geo.rsmKey,
          className: styles$i.mimgNotInState,
          geography: geo,
          fill: "#8e8e8e"
        }));
      });
    }), this.props.stateMapData.cityMetroData.filter(function (x) {
      return x.firstYearActive <= asOfYear && x.lastYearActive >= asOfYear;
    }).map(function (p) {
      return /*#__PURE__*/React.createElement(Marker$1, {
        id: "mapGroup_" + p.mapGroupId,
        key: p.mapGroupId,
        coordinates: p.mapCoordinateArray,
        onClick: function onClick() {
          _this2.props.onClickOnMetro(p.mapGroupId, p.description);
        },
        onMouseOver: function onMouseOver() {
          _this2.setTooltipContent("mapGroup_" + p.mapGroupId, p.description);
        },
        onMouseLeave: function onMouseLeave() {
          _this2.setTooltipContent("", "");
        }
      }, /*#__PURE__*/React.createElement("g", {
        fill: "#35444290",
        stroke: "#35444220",
        strokeWidth: "1",
        strokeLinecap: "round",
        strokeLinejoin: "round",
        transform: "translate(-12, -24)"
      }, /*#__PURE__*/React.createElement("circle", {
        cx: "12",
        cy: "10",
        r: "2"
      }), /*#__PURE__*/React.createElement("path", {
        d: "M14 21.7C17.3 17 20 13 20 10a8 8 0 1 0-16 0c0 3 2.7 6.9 8 13.7z"
      })));
    }), this.state.tooltipTarget !== "" && /*#__PURE__*/React.createElement(Tooltip, {
      placement: "top",
      isOpen: this.state.tooltipContent !== "",
      toggle: this.toggleTooltip,
      target: this.state.tooltipTarget
    }, this.state.tooltipContent))), /*#__PURE__*/React.createElement("div", {
      className: "d-block d-md-none"
    }, "The map is not available on small screens. Please use the dropdown(s) below to select a state or region instead", /*#__PURE__*/React.createElement("div", {
      className: styles$i.flexRow
    }, /*#__PURE__*/React.createElement(Input, {
      type: "select",
      id: "selectGroupingType",
      name: "selectGroupingType",
      className: styles$i.dropdown,
      onChange: this.handleGroupTypeChange
    }, /*#__PURE__*/React.createElement("option", {
      id: "groupByNational",
      value: "groupByNational"
    }, "National Portfolio"), /*#__PURE__*/React.createElement("option", {
      id: "groupByState",
      value: "groupByState"
    }, "By State"), /*#__PURE__*/React.createElement("option", {
      id: "groupByRegion",
      value: "groupByRegion"
    }, "By Region"))), /*#__PURE__*/React.createElement("div", {
      className: styles$i.flexRow
    }, /*#__PURE__*/React.createElement(Input, {
      type: "select",
      id: "selectGroupingValue",
      name: "selectGroupingValue",
      className: styles$i.dropdown,
      onChange: this.handleGroupingValueChange,
      disabled: this.state.groupingType === "groupByNational"
    }, /*#__PURE__*/React.createElement("option", {
      id: "noValueSelected"
    }, "Select ", this.state.groupValue), this.state.groupingMembers.map(function (p) {
      return /*#__PURE__*/React.createElement("option", {
        key: p.id,
        value: p.value
      }, p.value);
    })))));
  };
  return MapChart;
}(Component);

var MapChartHolder = /*#__PURE__*/function (_Component) {
  _inheritsLoose(MapChartHolder, _Component);
  function MapChartHolder() {
    var _this;
    _this = _Component.call(this) || this;
    _this.SetTooltipContent = function (id, state) {
      var adj = "Sucks";
      if (state === "Colorado") {
        adj = "Rules";
      }
      if (id === "") {
        _this.setState({
          TooltipOpen: false,
          TooltipContent: ""
        });
      } else {
        _this.setState({
          TooltipTarget: id,
          TooltipContent: state + " " + adj,
          TooltipOpen: true
        });
      }
    };
    _this.onResetToNational = function () {
      _this.setState({
        placeName: "National Portfolio",
        placeData: _this.stateMapData.nationalData
      });
    };
    _this.onClickOnMetro = function (metroId, description) {
      var metroData = _this.state.stateMapData.cityMetroData.filter(function (x) {
        return x.mapGroupId === metroId;
      })[0];
      _this.setState({
        placeName: description,
        placeData: metroData
      });
    };
    _this.onClickOnState = function (id, state) {
      var stateData = _this.state.stateMapData.stateData.filter(function (x) {
        return x.stateName === state;
      })[0];
      _this.setState({
        placeName: state,
        placeData: stateData
      });
    };
    _this.ToggleTooltip = function () {};
    _this.geoUrl = "https://cdn.jsdelivr.net/npm/us-atlas@3/states-10m.json";
    var defaultPlaceData = {};
    defaultPlaceData.firstPropertySiteId = 1;
    defaultPlaceData.mostRecentPropertySiteId = 222;
    defaultPlaceData.dataByYear = [];
    defaultPlaceData.localEmployees = [];
    _this.defaultPlaceData = defaultPlaceData;
    _this.state = {
      stateMapData: null,
      TooltipOpen: false,
      TooltipContent: "",
      TooltipTarget: null,
      placeName: "National Portfolio"
    };
    _this.SetTooltipContent = _this.SetTooltipContent.bind(_assertThisInitialized(_this));
    _this.ToggleTooltip = _this.ToggleTooltip.bind(_assertThisInitialized(_this));
    return _this;
  }
  var _proto = MapChartHolder.prototype;
  _proto.componentDidMount = function componentDidMount() {
    this.stateMapData = this.props.stateMapData;
    this.setState({
      geography: this.props.geography,
      stateMapData: this.stateMapData,
      placeData: this.stateMapData.nationalData,
      placeName: "National Portfolio"
    });
  };
  _proto.render = function render() {
    if (!this.state.stateMapData) {
      return /*#__PURE__*/React.createElement("div", null, "Loading...");
    }
    return /*#__PURE__*/React.createElement(Fragment, null, /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement(MapChart, {
      asOfYear: 2012,
      mapTitle: "Monarch Acq History",
      stateMapData: this.state.stateMapData,
      SetTooltipContent: this.SetTooltipContent,
      onClickOnState: this.onClickOnState,
      onClickOnMetro: this.onClickOnMetro,
      onResetToNational: this.onResetToNational,
      geography: this.state.geography
    })), this.state.placeData && /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement(AcquisitionHistoryTable, {
      placeData: this.state.placeData,
      cutoffYear: 2000
    })));
  };
  return MapChartHolder;
}(Component);

var styles$j = {"flexRow":"_2JgZ5","flex0":"_2x9Co","flex1":"_SSh86","flex2":"_3ZS8v","flex3":"_2_wTU","overflowX":"_3Hspj","logEntryHeader":"_1Ph1S","headerCol":"__4k3F","first":"_3BiAV","previous":"_1MLsY","next":"_1ptQR","last":"_2ewKb","wide":"_2F4dD","logMessage":"_2t-1g","logEndivyList":"_1f_yI","paging":"_U7PVv","normalRow":"_2qs-d","logEndivyHeader":"_fereQ","selectedRow":"_LMJ_f","blurbWrapper":"_3zZzg","alignRight":"_3xokA","wrapper":"_m7y6q","row":"_2Z1Ji","dataHolder":"_3He3K","titleText":"_dI0TP","label":"_3dLCJ"};

class SupportLogSearchObject {
    constructor(start = 1, count = 10, keyWords = null,  selectedUsers = [], fromDate = null, toDate = null, severity = null, pageName = '', page, pageSize) {
        this.Start = start;
        this.Count = count;
        this.SelectedUsers = selectedUsers;
        this.Keywords = keyWords;
        this.FromDate = fromDate;
        this.ToDate = toDate;
        this.Severity = severity;
        this.PageName = pageName;
        this.Page = page;
        this.PageSize = pageSize;
    }
}

var SearchGrid = /*#__PURE__*/function (_Component) {
  _inheritsLoose(SearchGrid, _Component);
  function SearchGrid(props) {
    var _this;
    _this = _Component.call(this, props) || this;
    _this.showLogEntry = function (e) {
      _this.setState({
        logEntry: _this.state.logEntries.filter(function (l) {
          return l.logId == e.currentTarget.id;
        })[0],
        selectedId: e.currentTarget.id
      });
    };
    _this.showdataRecord = function (e) {
      var record = _this.state.logEntries.filter(function (l) {
        return l[_this.props.keyField] == e.currentTarget.id;
      })[0];
      _this.setState({
        dataRecord: record,
        selectedId: e.currentTarget.id
      });
    };
    _this.onSelectPositions = function (e) {
      var selectedUsers = [];
      if (e.length > 0) {
        selectedUsers.push(e.map(function (x) {
          return x.value;
        }));
      } else {
        selectedUsers = [];
      }
      _this.setState({
        selectedUsers: selectedUsers
      });
    };
    _this.formatMessage = function (val, maxLength, isDate) {
      var message = val.toString();
      if (isDate) {
        return new Date(message).toLocaleDateString() + '\t ' + new Date(message).toLocaleTimeString();
      } else {
        message = _this.replaceAll(message, 'http://localhost:5918', '');
        message = _this.replaceAll(message, 'http://localhost:5900', '');
        message = _this.replaceAll(message, 'http://localhost:5000', '');
        message = _this.replaceAll(message, 'https://mimg.us', '');
      }
      if (maxLength == 0) {
        return message;
      } else {
        return message.substr(0, maxLength);
      }
    };
    _this.searchByKeywords = function (e, btn) {
      _this.setState({
        logEntry: null,
        logEntries: btn ? null : _this.state.logEntries,
        datasetReady: false
      });
      console.log('search: ' + _this.state.selectedUsers);
      var l_selectedUsers = [];
      for (var i in _this.state.selectedUsers[0]) {
        l_selectedUsers.push(_this.state.selectedUsers[0][i]);
      }
      var keyWords = document.getElementById('txtKeywordSearch').value.split(',');
      var dateFrom = document.getElementById('datePickerFrom').value;
      var dateTo = document.getElementById('datePickerTo').value;
      var severity = document.getElementById('ddlSeverity').value;
      var pageName = document.getElementById('txtPageName').value;
      var page = btn ? 1 : _this.state.page;
      var searchObj = new SupportLogSearchObject(_this.state.start, _this.state.pageSize, keyWords, _this.props.selectedUsers ? _this.props.selectedUsers : l_selectedUsers, dateFrom, dateTo, severity, pageName, page, _this.state.pageSize);
      console.log(searchObj);
      var myThis = _assertThisInitialized(_this);
      axios$1.post("api/LogViewer/GetAll", searchObj).then(function (response) {
        var le = response.data.data;
        for (var i in le) {
          le[i].message = _this.replaceAll(le[i].message, ' at ', '<br />&emsp;at ');
        }
        var pageCount = parseInt(response.data.recordCount / myThis.state.pageSize);
        if (response.data.recordCount % myThis.state.pageSize > 0) pageCount++;
        _this.setState({
          logEntries: le,
          keyWords: keyWords,
          recordCount: response.data.recordCount,
          page: page,
          pageCount: pageCount,
          datasetReady: true
        });
      })["catch"](function (ex) {
        debugger;
      });
    };
    _this.clear = function () {
      document.getElementById('txtKeywordSearch').value = '';
      document.getElementById('ddlSeverity').selectedIndex = 0;
      document.getElementById('txtPageName').value = '';
      _this.setState({
        keyWords: '',
        logEntries: [],
        pageName: '',
        beginDate: '',
        endDate: ''
      });
      _this.forceUpdate();
    };
    _this.escapeRegExp = function (string) {
      return string.replace(/[.*+?^${}()|[\]\\]/g, '\\$&');
    };
    _this.replaceAll = function (str, find, replace) {
      return str.replace(new RegExp(_this.escapeRegExp(find), 'g'), replace);
    };
    _this.state = {
      start: 1,
      count: 10,
      dataRecord: null,
      recordCount: 10,
      page: 1,
      pageSize: 10,
      pageCount: 1,
      logEntries: [],
      keyField: 'logId',
      keyWords: '',
      selectedUsers: _this.props.selectedUsers ? _this.props.selectedUsers.map(function (e) {
        return e.value;
      }) : []
    };
    _this.showdataRecord = _this.showdataRecord.bind(_assertThisInitialized(_this));
    _this.showLogEntry = _this.showLogEntry.bind(_assertThisInitialized(_this));
    _this.searchByKeywords = _this.searchByKeywords.bind(_assertThisInitialized(_this));
    _this.clear = _this.clear.bind(_assertThisInitialized(_this));
    _this.formatMessage = _this.formatMessage.bind(_assertThisInitialized(_this));
    return _this;
  }
  var _proto = SearchGrid.prototype;
  _proto.componentDidMount = function componentDidMount() {
    var dt = new Date();
    var endDate = dt.toISOString().substr(0, 10);
    dt.setDate(dt.getDate() - 30);
    var beginDate = dt.toISOString().substr(0, 10);
    this.setState({
      beginDate: beginDate,
      endDate: endDate
    });
  };
  _proto.onPageClick = function onPageClick(e, iPageDirection) {
    var _this2 = this;
    if (!this.state.datasetReady) return;
    var newPageNum = 0;
    switch (iPageDirection) {
      case 0:
        newPageNum = 1;
        break;
      case 1:
        if (this.state.page > 0) newPageNum = this.state.page - 1;
        break;
      case 2:
        if (this.state.page < this.state.pageCount) newPageNum = this.state.page + 1;
        break;
      case 3:
        newPageNum = Math.max(0, parseInt(this.state.recordCount / this.state.pageSize));
        if (this.state.recordCount % this.state.pageSize > 0) newPageNum++;
        break;
    }
    this.setState({
      page: newPageNum,
      datasetReady: false
    }, function () {
      return _this2.searchByKeywords();
    });
    return 1;
  };
  _proto.render = function render() {
    var _this3 = this;
    return /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement(Form, {
      id: "GridForm",
      onSubmit: this.onSubmit
    }, /*#__PURE__*/React.createElement(Row, null, /*#__PURE__*/React.createElement(Col, {
      md: 6
    }, /*#__PURE__*/React.createElement(Label, {
      "for": "txtKeywordSearch",
      className: styles$j.flexItemLabel
    }, "Keywords:"), /*#__PURE__*/React.createElement(Input, {
      type: "text",
      id: "txtKeywordSearch",
      defaultValue: this.state.keyWords
    })), /*#__PURE__*/React.createElement(Col, {
      md: 6
    }, /*#__PURE__*/React.createElement(Label, {
      "for": "txtPageName",
      className: styles$j.flexItemLabel
    }, "Page:"), /*#__PURE__*/React.createElement(Input, {
      type: "text",
      id: "txtPageName",
      defaultValue: this.state.pageName
    }))), /*#__PURE__*/React.createElement(Row, {
      className: styles$j.paddedRow
    }, /*#__PURE__*/React.createElement(Col, {
      md: 3
    }, /*#__PURE__*/React.createElement(Label, {
      className: styles$j.flexItemLabel,
      "for": "datePickerFrom"
    }, "From"), /*#__PURE__*/React.createElement(Input, {
      id: "datePickerFrom",
      name: "datePickerFrom",
      type: "date",
      defaultValue: this.state.beginDate
    })), /*#__PURE__*/React.createElement(Col, {
      md: 3
    }, /*#__PURE__*/React.createElement(Label, {
      className: styles$j.flexItemLabel,
      "for": "datePickerTo"
    }, "To"), /*#__PURE__*/React.createElement(Input, {
      id: "datePickerTo",
      name: "datePickerTo",
      type: "date",
      defaultValue: this.state.endDate
    })), /*#__PURE__*/React.createElement(Col, {
      md: 3
    }, /*#__PURE__*/React.createElement(Label, {
      "for": "ddlUser",
      className: styles$j.flexItemLabel
    }, "User:"), /*#__PURE__*/React.createElement(Select, {
      type: "select",
      id: "ddlUser",
      isMulti: true,
      closeMenuOnSelect: false,
      options: this.props.userList,
      defaultValue: this.props.populateFirstUser ? this.props.userList[0] : null,
      onChange: this.onSelectPositions,
      placeholder: "Select a User or Users to Filter By"
    })), /*#__PURE__*/React.createElement(Col, {
      md: 3
    }, /*#__PURE__*/React.createElement(Label, {
      className: styles$j.flexItemLabel,
      "for": "ddlSeverity"
    }, "Severity:"), /*#__PURE__*/React.createElement(Input, {
      type: "select",
      id: "ddlSeverity"
    }, /*#__PURE__*/React.createElement("option", {
      value: ""
    }), /*#__PURE__*/React.createElement("option", {
      value: "0"
    }, "0"), /*#__PURE__*/React.createElement("option", {
      value: "1"
    }, "1"), /*#__PURE__*/React.createElement("option", {
      value: "2"
    }, "2"), /*#__PURE__*/React.createElement("option", {
      value: "3"
    }, "3")))), /*#__PURE__*/React.createElement(Row, null, /*#__PURE__*/React.createElement(Col, {
      md: 6
    }, "\xA0"), /*#__PURE__*/React.createElement(Col, {
      md: 6
    }, /*#__PURE__*/React.createElement(Button$2, {
      color: "primary",
      onClick: function onClick(event) {
        return _this3.searchByKeywords(event, _this3);
      }
    }, "Search"), /*#__PURE__*/React.createElement(Button$2, {
      color: "secondary",
      onClick: function onClick(event) {
        return _this3.clear(event, _this3);
      }
    }, "Reset")))), this.state.logEntries && this.state.logEntries.length > 0 && /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement("br", null), /*#__PURE__*/React.createElement("br", null), /*#__PURE__*/React.createElement("div", {
      className: styles$j.wrapper
    }, /*#__PURE__*/React.createElement(Row, {
      className: styles$j.logEntryHeader
    }, /*#__PURE__*/React.createElement(Col, {
      md: 2,
      sm: 12
    }, "Created"), /*#__PURE__*/React.createElement(Col, {
      md: 3,
      sm: 12
    }, "Page"), /*#__PURE__*/React.createElement(Col, {
      md: 2,
      sm: 12
    }, "Procedure"), /*#__PURE__*/React.createElement(Col, {
      md: 4,
      sm: 12
    }, "Message"), /*#__PURE__*/React.createElement(Col, {
      md: 1,
      sm: 12
    }, "Severity")), this.state.logEntries.map(function (record, index) {
      return /*#__PURE__*/React.createElement("div", {
        onClick: _this3.showLogEntry,
        className: _this3.props.keyField && styles$j.flexRow && _this3.state.selectedId == record[_this3.props.keyField] ? styles$j.selectedRow + ' row' : styles$j.normalRow + ' row',
        id: record[_this3.props.keyField],
        key: record[_this3.props.keyField]
      }, /*#__PURE__*/React.createElement(Row, null, /*#__PURE__*/React.createElement(Col, {
        md: 2,
        sm: 12
      }, _this3.formatMessage(record.createDateTime, 0, true)), /*#__PURE__*/React.createElement(Col, {
        md: 3,
        sm: 12,
        className: styles$j.overflowX
      }, _this3.formatMessage(record.pageName, 0)), /*#__PURE__*/React.createElement(Col, {
        md: 2,
        sm: 12,
        className: styles$j.overflowX
      }, record.procedureName), /*#__PURE__*/React.createElement(Col, {
        md: 4,
        sm: 12,
        className: styles$j.overflowX
      }, _this3.formatMessage(record.message, 50)), /*#__PURE__*/React.createElement(Col, {
        md: 1,
        sm: 12
      }, record.severity)));
    })), "Page: ", this.state.page, " of ", Math.max(parseInt(this.state.pageCount), 1), " (", this.state.recordCount, " records found.)", /*#__PURE__*/React.createElement(Row, {
      className: styles$j.wide
    }, /*#__PURE__*/React.createElement(Col, {
      md: 3
    }, /*#__PURE__*/React.createElement(Button$2, {
      color: "primary",
      onClick: function onClick(e) {
        return _this3.onPageClick(e, 0);
      },
      className: styles$j.wide
    }, "<<")), /*#__PURE__*/React.createElement(Col, {
      md: 3
    }, /*#__PURE__*/React.createElement(Button$2, {
      color: "primary",
      onClick: function onClick(e) {
        return _this3.onPageClick(e, 1);
      },
      className: styles$j.wide
    }, "<")), /*#__PURE__*/React.createElement(Col, {
      md: 3
    }, /*#__PURE__*/React.createElement(Button$2, {
      color: "secondary",
      onClick: function onClick(e) {
        return _this3.onPageClick(e, 2);
      },
      className: styles$j.wide
    }, ">")), /*#__PURE__*/React.createElement(Col, {
      md: 3
    }, /*#__PURE__*/React.createElement(Button$2, {
      color: "primary",
      onClick: function onClick(e) {
        return _this3.onPageClick(e, 3);
      },
      className: styles$j.wide
    }, ">>")))), this.state.logEntries && this.state.logEntries.length == 0 && this.state.keyWords && /*#__PURE__*/React.createElement("span", null, /*#__PURE__*/React.createElement("br", null), /*#__PURE__*/React.createElement("br", null), "No Logs Found"), this.state.logEntry && /*#__PURE__*/React.createElement("span", null, /*#__PURE__*/React.createElement("br", null), /*#__PURE__*/React.createElement("br", null), /*#__PURE__*/React.createElement("hr", null), "Log ID: ", /*#__PURE__*/React.createElement("span", null, this.state.logEntry.logId), /*#__PURE__*/React.createElement("br", null), "Date: ", /*#__PURE__*/React.createElement("span", null, new Date(this.state.logEntry.createDateTime).toLocaleDateString() + ' ' + new Date(this.state.logEntry.createDateTime).toLocaleTimeString()), "\xA0\xA0\xA0\xA0 Page: ", /*#__PURE__*/React.createElement("span", null, /*#__PURE__*/React.createElement("a", {
      href: this.state.logEntry.pageName,
      target: "_blank"
    }, this.state.logEntry.pageName)), /*#__PURE__*/React.createElement("br", null), "User: ", /*#__PURE__*/React.createElement("span", null, this.state.logEntry.userName), /*#__PURE__*/React.createElement("br", null), "Prop ID: ", /*#__PURE__*/React.createElement("span", null, this.state.logEntry.propertyID), /*#__PURE__*/React.createElement("br", null), "Proc: ", /*#__PURE__*/React.createElement("span", null, this.state.logEntry.procedureName), /*#__PURE__*/React.createElement("br", null), /*#__PURE__*/React.createElement("div", {
      className: this.state.selectedId ? styles$j.logMessage : "",
      dangerouslySetInnerHTML: {
        __html: this.state.logEntry.message
      }
    })));
  };
  return SearchGrid;
}(Component);

var styles$k = {"wrapper":"_37wqg","iframeWrapper":"_gsBx9","videoContainer":"_1jdE6"};

function VideoPlayer(props) {
  return /*#__PURE__*/React.createElement("div", {
    className: styles$k.iframeWrapper
  }, /*#__PURE__*/React.createElement("div", {
    className: styles$k.videoContainer
  }, /*#__PURE__*/React.createElement("video", {
    controls: true
  }, /*#__PURE__*/React.createElement("source", {
    src: props.pathToVideo,
    type: props.videoMimeType ? props.videoMimeType : "video/mp4"
  }))));
}

var styles$l = {"wrapper":"_1GCjd","info":"_3A3O6","label":"_2vsJU","propName":"_2uAoj","header":"_1uVfr","flexRow":"_DPugD","flexRowHeadFoot":"_22IKe","flex1":"_h5qD2","flex2":"_2Sv5B","flex3":"_1EOj8"};

function percent(decimal) {
  if (decimal === 0) {
    return "";
  } else {
    var valueFormat = Intl.NumberFormat("en-GB", {
      style: "percent",
      minimumFractionDigits: 2,
      maximumFractionDigits: 2
    }).format(decimal);
    return valueFormat;
  }
}
function currency(amount) {
  if (amount === 0) {
    return 0;
  } else {
    var valueFormat = Intl.NumberFormat("en-US", {
      style: "currency",
      currency: "USD",
      maximumFractionDigits: 0
    }).format(amount);
    return valueFormat;
  }
}

var styles$m = {"sideFilter":"_2e11y","list":"_3qmtF","smallInfo":"_2PGVH","checkbox":"_AOLmT","label":"_3WBWD"};

function SideFilter(props) {
  var _useState = useState([props.portfolio]),
    selectedProps = _useState[0],
    setSelectedProps = _useState[1];
  var propList = props.list;
  function selectedItemsChange(status, prop) {
    var items = JSON.parse(JSON.stringify(selectedProps));
    var prop = parseInt(prop);
    if (status && prop === props.portfolio) {
      items = [].concat(new Set(propList.map(function (x) {
        return x.value;
      })));
      items.push(props.portfolio);
    } else if (status && items.indexOf(prop) === -1) {
      items.push(prop);
    } else {
      items = items.filter(function (item) {
        return item !== prop;
      });
    }
    setSelectedProps(items);
    props.filterList(items);
  }
  function isChecked(prop) {
    if (selectedProps.includes(prop)) {
      return true;
    } else {
      return false;
    }
  }
  return /*#__PURE__*/React.createElement("div", {
    className: styles$m.sideFilter
  }, /*#__PURE__*/React.createElement("div", {
    className: styles$m.label
  }, "Select Properties"), /*#__PURE__*/React.createElement("br", null), /*#__PURE__*/React.createElement("div", {
    className: styles$m.smallInfo
  }, "Highlight properties to show data ", /*#__PURE__*/React.createElement("br", null), "Select the portfolio to show all"), /*#__PURE__*/React.createElement("br", null), /*#__PURE__*/React.createElement(Form, {
    className: styles$m.list
  }, propList.map(function (x, index) {
    return /*#__PURE__*/React.createElement(Label, {
      key: index
    }, /*#__PURE__*/React.createElement(Input, {
      className: styles$m.checkbox,
      type: "checkbox",
      name: x.value,
      checked: isChecked(x.value),
      onChange: function onChange(e) {
        return selectedItemsChange(e.target.checked, e.target.name);
      }
    }), /*#__PURE__*/React.createElement("span", null, x.label));
  })));
}

function useWindowSize() {
  var _useState = useState([0, 0]),
    size = _useState[0],
    setSize = _useState[1];
  useLayoutEffect(function () {
    function updateSize() {
      setSize([window.innerWidth, window.innerHeight]);
    }
    window.addEventListener('resize', updateSize);
    updateSize();
    return function () {
      return window.removeEventListener('resize', updateSize);
    };
  }, []);
  return size;
}

function LoanInfo(props) {
  var _useState = useState(),
    loanList = _useState[0],
    setLoanList = _useState[1];
  var _useState2 = useState(),
    loanListFiltered = _useState2[0],
    setLoanListFiltered = _useState2[1];
  var _useState3 = useState(),
    loanDcr = _useState3[0],
    setLoanDcr = _useState3[1];
  var _useState4 = useState(),
    loanDcrFiltered = _useState4[0],
    setLoanDcrFiltered = _useState4[1];
  var _useState5 = useState(null),
    portfolioDsc = _useState5[0],
    setPortfolioDsc = _useState5[1];
  var _useState6 = useState([]),
    selectedProps = _useState6[0],
    setSelectedProps = _useState6[1];
  var _useState7 = useState(),
    t12Date = _useState7[0],
    setT12Date = _useState7[1];
  var _useState8 = useState(),
    t3Date = _useState8[0],
    setT3Date = _useState8[1];
  var _useState9 = useState(),
    currDate = _useState9[0],
    setCurrDate = _useState9[1];
  var _useState10 = useState(false),
    isPortfolio = _useState10[0],
    setIsPortfolio = _useState10[1];
  var _useState11 = useState([]),
    propList = _useState11[0],
    setPropList = _useState11[1];
  var _useWindowSize = useWindowSize(),
    width = _useWindowSize[0];
  var medStyle = width < 1200 || isMobile ? true : false;
  useEffect(function () {
    if (props.siteId) {
      instance.get("api/loaninfo/getloanlist?invWebsiteId=" + props.siteId).then(function (res) {
        setLoanList(res.data);
        setLoanListFiltered(res.data);
        setSelectedProps([props.property]);
      });
      instance.get("api/loaninfo/getloanInfoForDcr?invWebsiteId=" + props.siteId).then(function (res) {
        setIsPortfolio(res.data[0].invWebsiteId !== res.data[0].siteId);
        var list = res.data.map(function (x) {
          return {
            label: x.propertyName,
            value: x.siteId
          };
        });
        list.unshift({
          label: props.property,
          value: props.siteId
        });
        setPropList(list);
        setLoanDcr(res.data);
        setLoanDcrFiltered(res.data);
        setT12Date(moment(res.data[0].t12startDate).format("M/YY"));
        setT3Date(moment(res.data[0].cqStart).format("M/YY"));
        setCurrDate(moment(res.data[0].finsEnd).format("M/YY"));
      });
    }
  }, [props.siteId]);
  useEffect(function () {
    if (loanDcr) {
      portfolioDscCalc(loanDcr);
    }
  }, [loanDcr]);
  function portfolioDscCalc(loans) {
    if (isPortfolio && parseInt(loans[0].includeQtr) === 1) {
      var amoDs = loans.map(function (x) {
        return x.amoDs;
      }).reduce(function (a, b) {
        return a + b;
      }, 0);
      var ioDs = loans.map(function (x) {
        return x.ioDebtService;
      }).reduce(function (a, b) {
        return a + b;
      }, 0);
      var currDs = ioDs > 0 ? ioDs : amoDs;
      var t3Noi = loans.map(function (x) {
        return x.t3noi;
      }).reduce(function (a, b) {
        return a + b;
      }, 0) * 4;
      var t12Noi = parseInt(loans[0].includeT12) === 1 ? loans.map(function (x) {
        return x.t12noi;
      }).reduce(function (a, b) {
        return a + b;
      }, 0) : null;
      setPortfolioDsc({
        t3Noi: t3Noi,
        t12Noi: t12Noi,
        currDs: currDs,
        amoDs: amoDs,
        t12AmoDsc: (t12Noi / amoDs).toFixed(2),
        t3AmoDsc: (t3Noi / amoDs).toFixed(2),
        t12CurrDsc: (t12Noi / currDs).toFixed(2),
        t3CurrDsc: (t3Noi / currDs).toFixed(2)
      });
    } else {
      setPortfolioDsc(null);
    }
  }
  function filterList(items) {
    setLoanDcrFiltered(loanDcr.filter(function (p) {
      return items.includes(p.siteId);
    }));
    var listPropertyNames = loanDcr.filter(function (p) {
      return items.includes(p.siteId);
    }).map(function (x) {
      return x.propertyName;
    });
    setLoanListFiltered(loanList.filter(function (p) {
      return listPropertyNames.includes(p.propertyName);
    }));
  }
  function dsc(loan, t, type) {
    var DSC = 0.0;
    if (type === 'amo') {
      if (t === 't12') {
        DSC = loan.t12noi / loan.amoDs;
      } else {
        DSC = loan.t3noi * 4 / loan.amoDs;
      }
    }
    if (type === 'cur') {
      if (t === 't12') {
        DSC = loan.ioDebtService ? loan.t12noi / loan.ioDebtService : loan.t12noi / loan.amoDs;
      } else {
        DSC = loan.ioDebtService ? loan.t3noi * 4 / loan.ioDebtService : loan.t3noi * 4 / loan.amoDs;
      }
    }
    return DSC.toFixed(2);
  }
  function ds(propCode, type) {
    var dcr = loanDcr.filter(function (d) {
      return d.yardiCode.toUpperCase() === propCode.toUpperCase();
    })[0];
    var DS;
    if (dcr) {
      if (type === 'cur' && dcr.ioDebtService > 0) {
        DS = dcr.ioDebtService;
      } else {
        DS = dcr.amoDs;
      }
      return currency(DS);
    }
    return 0;
  }
  return /*#__PURE__*/React.createElement("div", {
    className: styles$l.wrapper
  }, loanListFiltered && loanDcrFiltered && /*#__PURE__*/React.createElement(Fragment, null, isPortfolio && !isMobile && !medStyle && /*#__PURE__*/React.createElement(SideFilter, {
    list: propList,
    portfolio: props.siteId,
    filterList: filterList
  }), /*#__PURE__*/React.createElement("div", {
    className: styles$l.flex2 + " " + styles$l.info
  }, /*#__PURE__*/React.createElement("div", {
    className: styles$l.label
  }, "Loan List"), /*#__PURE__*/React.createElement("br", null), loanListFiltered.map(function (x, index) {
    return /*#__PURE__*/React.createElement("div", {
      className: styles$l.flex1,
      key: index
    }, /*#__PURE__*/React.createElement("div", {
      className: styles$l.propName
    }, x.propertyName), /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement("b", null, "Lender & Program:"), " ", x.lenderName, " (", x.loanProgram, ")"), /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement("b", null, "Loan Type:"), " ", x.primaryOrSupp), /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement("b", null, "Initial Payment:"), " ", x.initialPaymentDate), /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement("b", null, "Final IO Payment:"), " ", x.ioEndDate), /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement("b", null, "Maturity Date:"), " ", x.maturityDate), /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement("b", null, "Initial Balance:"), " ", currency(x.initialBalance)), /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement("b", null, "Current Balance:"), " ", currency(x.mortgageBalance)), /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement("b", null, "Term and Rate:"), " ", x.term, " Year Term, ", (x.rate * 100).toFixed(2), "% Rate"), /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement("b", null, "Current Debt Service:"), " ", ds(x.yardiCode, 'cur')), /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement("b", null, "Fully Amortizing DS:"), " ", ds(x.yardiCode, 'amo')), /*#__PURE__*/React.createElement("br", null));
  })), /*#__PURE__*/React.createElement("div", {
    className: styles$l.flex3 + " " + styles$l.info
  }, /*#__PURE__*/React.createElement("div", {
    className: styles$l.label
  }, "Debt Service Coverage Ratio"), /*#__PURE__*/React.createElement("br", null), portfolioDsc && selectedProps.includes(props.property) && /*#__PURE__*/React.createElement(Fragment, null, /*#__PURE__*/React.createElement("div", {
    className: styles$l.propName
  }, "Portfolio"), /*#__PURE__*/React.createElement("div", {
    className: styles$l.flexRowHeadFoot + " " + styles$l.header
  }, /*#__PURE__*/React.createElement("div", {
    className: styles$l.flex1
  }), /*#__PURE__*/React.createElement("div", {
    className: styles$l.flex1
  }, "NOI"), /*#__PURE__*/React.createElement("div", {
    className: styles$l.flex1
  }, "Current DS ", currency(portfolioDsc.currDs)), /*#__PURE__*/React.createElement("div", {
    className: styles$l.flex1
  }, "Full Amo ", currency(portfolioDsc.amoDs))), portfolioDsc.t12Noi && /*#__PURE__*/React.createElement("div", {
    className: styles$l.flexRow
  }, /*#__PURE__*/React.createElement("div", {
    className: styles$l.flex1
  }, t12Date, " - ", currDate), /*#__PURE__*/React.createElement("div", {
    className: styles$l.flex1
  }, currency(portfolioDsc.t12Noi)), /*#__PURE__*/React.createElement("div", {
    className: styles$l.flex1
  }, portfolioDsc.t12CurrDsc), /*#__PURE__*/React.createElement("div", {
    className: styles$l.flex1
  }, portfolioDsc.t12AmoDsc)), /*#__PURE__*/React.createElement("div", {
    className: styles$l.flexRow
  }, /*#__PURE__*/React.createElement("div", {
    className: styles$l.flex1
  }, t3Date, " - ", currDate), /*#__PURE__*/React.createElement("div", {
    className: styles$l.flex1
  }, currency(portfolioDsc.t3Noi)), /*#__PURE__*/React.createElement("div", {
    className: styles$l.flex1
  }, portfolioDsc.t3CurrDsc), /*#__PURE__*/React.createElement("div", {
    className: styles$l.flex1
  }, portfolioDsc.t3AmoDsc)), /*#__PURE__*/React.createElement("br", null)), loanDcrFiltered.map(function (x, index) {
    return /*#__PURE__*/React.createElement("div", {
      key: index
    }, parseInt(x.includeQtr) ? /*#__PURE__*/React.createElement("div", {
      key: index
    }, /*#__PURE__*/React.createElement("div", {
      className: styles$l.propName
    }, x.propertyName), /*#__PURE__*/React.createElement("div", {
      className: styles$l.flexRowHeadFoot + " " + styles$l.header
    }, /*#__PURE__*/React.createElement("div", {
      className: styles$l.flex1
    }), /*#__PURE__*/React.createElement("div", {
      className: styles$l.flex1
    }, "NOI"), /*#__PURE__*/React.createElement("div", {
      className: styles$l.flex1
    }, "Current DS ", x.ioDebtService ? currency(x.ioDebtService) : currency(x.amoDs)), /*#__PURE__*/React.createElement("div", {
      className: styles$l.flex1
    }, "Full Amo ", /*#__PURE__*/React.createElement("br", null), currency(x.amoDs))), parseInt(x.includeT12) === 1 && /*#__PURE__*/React.createElement("div", {
      className: styles$l.flexRow
    }, /*#__PURE__*/React.createElement("div", {
      className: styles$l.flex1
    }, t12Date, " - ", currDate), /*#__PURE__*/React.createElement("div", {
      className: styles$l.flex1
    }, currency(x.t12noi)), /*#__PURE__*/React.createElement("div", {
      className: styles$l.flex1
    }, dsc(x, 't12', 'cur')), /*#__PURE__*/React.createElement("div", {
      className: styles$l.flex1
    }, dsc(x, 't12', 'amo'))), /*#__PURE__*/React.createElement("div", {
      className: styles$l.flexRow
    }, /*#__PURE__*/React.createElement("div", {
      className: styles$l.flex1
    }, t3Date, " - ", currDate), /*#__PURE__*/React.createElement("div", {
      className: styles$l.flex1
    }, currency(x.t3noi * 4)), /*#__PURE__*/React.createElement("div", {
      className: styles$l.flex1
    }, dsc(x, 't3', 'cur')), /*#__PURE__*/React.createElement("div", {
      className: styles$l.flex1
    }, dsc(x, 't3', 'amo'))), /*#__PURE__*/React.createElement("br", null)) : /*#__PURE__*/React.createElement("div", null, "This property is too new"));
  }))));
}

var styles$n = {"wrapper":"_39xvd","flexWrapper":"_1AAr3","chartWrapper":"_2qIK-","chart":"_2rqHf","label":"_3qnwi","propName":"_26wOC","tableType":"_15kGv","bold":"_3ju3A","header":"_1_v08","flexRow":"_2IWgH","flexRowHeadFoot":"_f8-Lq","flex1":"_3h4rJ","flex1a":"_fgajU","flex2":"_3ZFgO","flex3":"_2c_Qz","arrowDown":"_2wHMC","arrowUp":"_3Jo1u"};

function Performance(props) {
  var _useState = useState(),
    perf = _useState[0],
    setPerf = _useState[1];
  var _useState2 = useState(),
    minNoi = _useState2[0],
    setMinNoi = _useState2[1];
  var _useState3 = useState(),
    maxInc = _useState3[0],
    setMaxInc = _useState3[1];
  var _useState4 = useState(),
    minOcc = _useState4[0],
    setMinOcc = _useState4[1];
  var _useState5 = useState(),
    perfTableData = _useState5[0],
    setPerfTableData = _useState5[1];
  var _useState6 = useState(),
    tableFiltered = _useState6[0],
    setTableFiltered = _useState6[1];
  var _useState7 = useState(),
    data = _useState7[0],
    setData = _useState7[1];
  var _useState8 = useState(),
    options = _useState8[0],
    setOptions = _useState8[1];
  var _useState9 = useState(),
    months = _useState9[0],
    setMonths = _useState9[1];
  var _useState10 = useState(false),
    isPortfolio = _useState10[0],
    setIsPortfolio = _useState10[1];
  var _useState11 = useState(),
    propList = _useState11[0],
    setPropList = _useState11[1];
  var _useWindowSize = useWindowSize(),
    width = _useWindowSize[0];
  var medStyle = width < 1200 || isMobile ? true : false;
  var smStyle = width < 1000 || isMobile ? true : false;
  Chart.register(CategoryScale);
  function differenceInMonths(date1, date2) {
    var monthDiff = date1.getMonth() - date2.getMonth();
    var yearDiff = date1.getYear() - date2.getYear();
    return monthDiff + yearDiff * 12;
  }
  useEffect(function () {
    var monthsOwned = differenceInMonths(new Date(), new Date(props.startDate));
    var months = monthsOwned - 1;
    var maxMonths = months >= 24 ? -24 : -months;
    setMonths(months);
    axios$1.get("api/performance/getPerformanceChartData?siteId=" + props.siteId + "&months=" + months).then(function (res) {
      if (res.data) {
        setMinNoi(Math.min.apply(Math, res.data.slice(maxMonths).map(function (x) {
          return x.NOI;
        })));
        setMaxInc(Math.max.apply(Math, res.data.slice(maxMonths).map(function (x) {
          return x.TotalIncome;
        })));
        setMinOcc(Math.min.apply(Math, res.data.slice(maxMonths).map(function (x) {
          return x.AvgOccupancy;
        })));
      }
      setPerf(res.data.slice(maxMonths));
    });
    axios$1.get("api/performance/getPerformanceTableData?siteId=" + props.siteId).then(function (res) {
      setIsPortfolio(res.data.length > 1);
      var list = res.data.map(function (x) {
        return {
          label: x.PropertyName,
          value: x.SiteID
        };
      });
      list[0] = {
        label: props.property,
        value: props.siteId
      };
      setPropList(list);
      setPerfTableData(res.data);
      setTableFiltered(res.data);
    });
  }, [props.siteId, props.startDate]);
  useEffect(function () {
    if (perf && minNoi && maxInc) {
      setData({
        labels: perf.map(function (x) {
          return x.DateString;
        }),
        datasets: [{
          label: 'Occupancy',
          data: perf.map(function (x) {
            return x.AvgOccupancy;
          }),
          backgroundColor: ['#e8c08e'],
          borderColor: '#d59038',
          borderWidth: 2,
          order: 2,
          yAxisID: 'y-right',
          tension: 0.2
        }, {
          label: 'NOI',
          data: perf.map(function (x) {
            return x.NOI.toFixed(0);
          }),
          backgroundColor: ['#3f4f4a'],
          borderColor: '#3f4f4a',
          type: 'line',
          order: 1,
          yAxisID: 'y-left',
          tension: 0.2
        }, {
          label: 'Income',
          data: perf.map(function (x) {
            return x.TotalIncome.toFixed(0);
          }),
          backgroundColor: ['#d59038'],
          borderColor: '#d59038',
          type: 'line',
          order: 0,
          yAxisID: 'y-left',
          tension: 0.2
        }]
      });
      var scales = {
        x: {
          grid: {
            display: false
          }
        },
        "y-left": {
          type: "linear",
          position: 'left',
          title: {
            display: true,
            text: 'Income & NOI'
          },
          min: Math.floor(minNoi * 0.9 / 50000) * 50000,
          max: Math.ceil(maxInc * 1.1 / 50000) * 50000,
          ticks: {
            callback: function callback(label, index, labels) {
              return "$" + label / 1000 + 'k';
            }
          }
        },
        "y-right": {
          type: "linear",
          position: 'right',
          grid: {
            drawOnChartArea: false
          },
          title: {
            display: true,
            text: 'Occupancy'
          },
          min: minOcc - .03,
          max: 1,
          ticks: {
            callback: function callback(yValue) {
              return (yValue * 100).toFixed(0) + "%";
            }
          }
        }
      };
      setOptions({
        responsive: true,
        maintainAspectRatio: true,
        scales: scales,
        plugins: {
          tooltip: {
            mode: 'index',
            callbacks: {
              label: function label(context) {
                var label = "";
                if (context.dataset.label === "Occupancy") {
                  label = new Intl.NumberFormat('en-US', {
                    style: 'percent',
                    minimumFractionDigits: 0,
                    maximumFractionDigits: 1
                  }).format(context.formattedValue);
                } else {
                  label = "$" + context.formattedValue;
                }
                return context.dataset.label + ": " + label;
              },
              title: function title(context) {
                var title = context[0].label;
                return title;
              }
            }
          },
          legend: {
            display: true
          }
        }
      });
    }
  }, [perf, props.siteId]);
  function formatDate(date) {
    return moment(date).format("M/YY");
  }
  function renderTable(rowItem, x, dateRange) {
    var p = "";
    var c = "";
    if (dateRange === "quarter") {
      p = 'Pq' + rowItem;
      c = 'Cq' + rowItem;
    } else if (dateRange === "T12") {
      p = 'Py' + rowItem;
      c = 'Cy' + rowItem;
    } else {
      p = 'PySq' + rowItem;
      c = 'Cq' + rowItem;
    }
    return /*#__PURE__*/React.createElement(Fragment, null, /*#__PURE__*/React.createElement("div", {
      className: " " + styles$n.flex1 + " " + styles$n.bold
    }, rowItem), /*#__PURE__*/React.createElement("div", {
      className: styles$n.flex1
    }, currency(x[p])), /*#__PURE__*/React.createElement("div", {
      className: styles$n.flex1
    }, currency(x[c]), smStyle && /*#__PURE__*/React.createElement("span", {
      className: x[c] - x[p] < 0 ? "" + styles$n.arrowDown : "" + styles$n.arrowUp
    }, x[c] - x[p] < 0 ? /*#__PURE__*/React.createElement(VscTriangleDown, null) : /*#__PURE__*/React.createElement(VscTriangleUp, null), " ")), !smStyle && /*#__PURE__*/React.createElement(Fragment, null, /*#__PURE__*/React.createElement("div", {
      className: styles$n.flex1,
      style: {
        color: Math.sign(x[c] - x[p]) === -1 ? "red" : "black"
      }
    }, currency(x[c] - x[p])), /*#__PURE__*/React.createElement("div", {
      className: styles$n.flex1,
      style: {
        color: Math.sign(x[c] - x[p]) === -1 ? "red" : "black"
      }
    }, percent((x[c] - x[p]) / x[p]))));
  }
  function filterList(items) {
    setTableFiltered(perfTableData.filter(function (p) {
      return items.includes(p.SiteID);
    }));
  }
  function getGraphLabel() {
    if (months >= 24) {
      return 'Quarterly' + (isPortfolio ? ' Portfolio ' : ' Property ') + 'Performance';
    } else {
      return 'monthly' + (isPortfolio ? ' Portfolio ' : ' Property ') + 'Performance';
    }
  }
  return /*#__PURE__*/React.createElement(Container, {
    className: styles$n.wrapper
  }, months < 7 ? /*#__PURE__*/React.createElement("div", null, "The performance chart will become available once the investment has been held for 6 months") : /*#__PURE__*/React.createElement(Fragment, null, perf && options && data && propList && /*#__PURE__*/React.createElement("div", {
    className: styles$n.flexWrapper
  }, isPortfolio && !medStyle && /*#__PURE__*/React.createElement(SideFilter, {
    list: propList,
    portfolio: props.siteId,
    filterList: filterList
  }), /*#__PURE__*/React.createElement("div", {
    className: styles$n.flex1
  }, /*#__PURE__*/React.createElement("div", {
    className: styles$n.label
  }, getGraphLabel()), /*#__PURE__*/React.createElement("div", {
    className: styles$n.chartWrapper
  }, /*#__PURE__*/React.createElement(Bar, {
    className: styles$n.chart + " " + styles$n.flex1,
    data: data,
    options: options
  })), /*#__PURE__*/React.createElement("br", null), tableFiltered && /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement("div", null, tableFiltered.map(function (x, index) {
    return /*#__PURE__*/React.createElement("div", {
      key: index,
      className: styles$n.flex1a
    }, /*#__PURE__*/React.createElement("div", {
      className: styles$n.label
    }, x.PropertyName), x.IncludeT12 === 1 && /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement("div", {
      className: styles$n.tableType
    }, "T12 Changes"), /*#__PURE__*/React.createElement("div", {
      className: styles$n.flexRowHeadFoot + " " + styles$n.header
    }, /*#__PURE__*/React.createElement("div", {
      className: styles$n.flex1
    }), /*#__PURE__*/React.createElement("div", {
      className: styles$n.flex1
    }, formatDate(x.PyT12Start), "-", formatDate(x.PyT12End)), /*#__PURE__*/React.createElement("div", {
      className: styles$n.flex1
    }, formatDate(x.CyT12Start), "-", formatDate(x.CyT12End)), !smStyle && /*#__PURE__*/React.createElement(Fragment, null, /*#__PURE__*/React.createElement("div", {
      className: styles$n.flex1
    }, "Diff"), /*#__PURE__*/React.createElement("div", {
      className: styles$n.flex1
    }, "Change"))), /*#__PURE__*/React.createElement("div", {
      className: styles$n.flexRow
    }, renderTable("T12Income", x, "T12")), /*#__PURE__*/React.createElement("div", {
      className: styles$n.flexRow
    }, renderTable("T12Expense", x, "T12")), /*#__PURE__*/React.createElement("div", {
      className: styles$n.flexRow
    }, renderTable("T12NOI", x, "T12")), /*#__PURE__*/React.createElement("div", {
      className: styles$n.flexRow
    }, /*#__PURE__*/React.createElement("div", {
      className: " " + styles$n.flex1 + " " + styles$n.bold
    }, "Occupied"), /*#__PURE__*/React.createElement("div", {
      className: styles$n.flex1
    }, percent(x.PyT12Occ)), /*#__PURE__*/React.createElement("div", {
      className: styles$n.flex1
    }, percent(x.CyT12Occ), smStyle && /*#__PURE__*/React.createElement("span", {
      className: x.CyT12Occ - x.PyT12Occ < 0 ? "" + styles$n.arrowDown : "" + styles$n.arrowUp
    }, x.CyT12Occ - x.PyT12Occ < 0 ? /*#__PURE__*/React.createElement(VscTriangleDown, null) : /*#__PURE__*/React.createElement(VscTriangleUp, null), " ")), !smStyle && /*#__PURE__*/React.createElement(Fragment, null, /*#__PURE__*/React.createElement("div", {
      className: styles$n.flex1,
      style: {
        color: Math.sign(x.CyT12Occ - x.PyT12Occ) === -1 ? "red" : "black"
      }
    }, percent(x.CyT12Occ - x.PyT12Occ)), /*#__PURE__*/React.createElement("div", {
      className: styles$n.flex1,
      style: {
        color: Math.sign(x.CyT12Occ - x.PyT12Occ) === -1 ? "red" : "black"
      }
    }, percent((x.CyT12Occ - x.PyT12Occ) / x.PyT12Occ)))), /*#__PURE__*/React.createElement("br", null)), x.IncludeQtr === 1 && /*#__PURE__*/React.createElement(Fragment, null, /*#__PURE__*/React.createElement("div", {
      className: styles$n.tableType
    }, "Quarter Over Quarter Changes"), /*#__PURE__*/React.createElement("div", {
      className: styles$n.flexRowHeadFoot + " " + styles$n.header
    }, /*#__PURE__*/React.createElement("div", {
      className: styles$n.flex1
    }), /*#__PURE__*/React.createElement("div", {
      className: styles$n.flex1
    }, formatDate(x.PqStart), "-", formatDate(x.PqEnd)), /*#__PURE__*/React.createElement("div", {
      className: styles$n.flex1
    }, formatDate(x.CqStart), "-", formatDate(x.CqEnd)), !smStyle && /*#__PURE__*/React.createElement(Fragment, null, /*#__PURE__*/React.createElement("div", {
      className: styles$n.flex1
    }, "Diff"), /*#__PURE__*/React.createElement("div", {
      className: styles$n.flex1
    }, "Change"))), /*#__PURE__*/React.createElement("div", {
      className: styles$n.flexRow
    }, renderTable("Income", x, "quarter")), /*#__PURE__*/React.createElement("div", {
      className: styles$n.flexRow
    }, renderTable("Expense", x, "quarter")), /*#__PURE__*/React.createElement("div", {
      className: styles$n.flexRow
    }, renderTable("NOI", x, "quarter")), /*#__PURE__*/React.createElement("div", {
      className: styles$n.flexRow
    }, /*#__PURE__*/React.createElement("div", {
      className: " " + styles$n.flex1 + " " + styles$n.bold
    }, "Occupied"), /*#__PURE__*/React.createElement("div", {
      className: styles$n.flex1
    }, percent(x.PqOcc)), /*#__PURE__*/React.createElement("div", {
      className: styles$n.flex1
    }, percent(x.CqOcc), smStyle && /*#__PURE__*/React.createElement("span", {
      className: x.CqOcc - x.PqOcc < 0 ? "" + styles$n.arrowDown : "" + styles$n.arrowUp
    }, x.CqOcc - x.PqOcc < 0 ? /*#__PURE__*/React.createElement(VscTriangleDown, null) : /*#__PURE__*/React.createElement(VscTriangleUp, null), " ")), !smStyle && /*#__PURE__*/React.createElement(Fragment, null, /*#__PURE__*/React.createElement("div", {
      className: styles$n.flex1,
      style: {
        color: Math.sign(x.CqOcc - x.PqOcc) === -1 ? "red" : "black"
      }
    }, percent(x.CqOcc - x.PqOcc)), /*#__PURE__*/React.createElement("div", {
      className: styles$n.flex1,
      style: {
        color: Math.sign(x.CqOcc - x.PqOcc) === -1 ? "red" : "black"
      }
    }, percent((x.CqOcc - x.PqOcc) / x.PqOcc)))), /*#__PURE__*/React.createElement("br", null)), x.IncludeYoy === 1 && /*#__PURE__*/React.createElement(Fragment, null, /*#__PURE__*/React.createElement("div", {
      className: styles$n.tableType
    }, "Year Over Year Changes"), /*#__PURE__*/React.createElement("div", {
      className: styles$n.flexRowHeadFoot + " " + styles$n.header
    }, /*#__PURE__*/React.createElement("div", {
      className: styles$n.flex1
    }), /*#__PURE__*/React.createElement("div", {
      className: styles$n.flex1
    }, formatDate(x.PyT12Start), "-", formatDate(x.PyT12End)), /*#__PURE__*/React.createElement("div", {
      className: styles$n.flex1
    }, formatDate(x.CyT12Start), "-", formatDate(x.CyT12End)), !smStyle && /*#__PURE__*/React.createElement(Fragment, null, /*#__PURE__*/React.createElement("div", {
      className: styles$n.flex1
    }, "Diff"), /*#__PURE__*/React.createElement("div", {
      className: styles$n.flex1
    }, "Change"))), /*#__PURE__*/React.createElement("div", {
      className: styles$n.flexRow
    }, renderTable("Income", x, "year")), /*#__PURE__*/React.createElement("div", {
      className: styles$n.flexRow
    }, renderTable("Expense", x, "year")), /*#__PURE__*/React.createElement("div", {
      className: styles$n.flexRow
    }, renderTable("NOI", x, "year")), /*#__PURE__*/React.createElement("div", {
      className: styles$n.flexRow
    }, /*#__PURE__*/React.createElement("div", {
      className: " " + styles$n.flex1 + " " + styles$n.bold
    }, "Occupied"), /*#__PURE__*/React.createElement("div", {
      className: styles$n.flex1
    }, percent(x.PySqOcc)), /*#__PURE__*/React.createElement("div", {
      className: styles$n.flex1
    }, percent(x.CqOcc), smStyle && /*#__PURE__*/React.createElement("span", {
      className: x.CqOcc - x.PySqOcc < 0 ? "" + styles$n.arrowDown : "" + styles$n.arrowUp
    }, x.CqOcc - x.PySqOcc < 0 ? /*#__PURE__*/React.createElement(VscTriangleDown, null) : /*#__PURE__*/React.createElement(VscTriangleUp, null), " ")), !smStyle && /*#__PURE__*/React.createElement(Fragment, null, /*#__PURE__*/React.createElement("div", {
      className: styles$n.flex1,
      style: {
        color: Math.sign(x.CqOcc - x.PySqOcc) === -1 ? "red" : "black"
      }
    }, percent(x.CqOcc - x.PySqOcc)), /*#__PURE__*/React.createElement("div", {
      className: styles$n.flex1,
      style: {
        color: Math.sign(x.CqOcc - x.PySqOcc) === -1 ? "red" : "black"
      }
    }, percent((x.CqOcc - x.PySqOcc) / x.PySqOcc)))), /*#__PURE__*/React.createElement("br", null)));
  })))))));
}

export { AcquisitionHistoryTable, ActionLink, AxiosInterceptor, Button, DeleteButton, EditButton, Email, ErrorLogModel, GenericEmailHistoryForm, IEnotSupported, Link, LinkButton, LoanInfo, LogGrid, MapChart, MapChartHolder, MapMarker, NavDropdownItem, NavDropdownItemHeader, NavDropdownTitle, NavLink, NotFoundPage, NotificationPage, Performance, Property, PropertyCard, PropertySearch, SearchGrid, SearchInput$1 as SearchInput, SideFilter, TabCategory, TabMenu, Test, TextInput$1 as TextInput, VideoPlayer, instance as axios, getEmailServiceUrl, getMIMGUrl, getNotificationAddresses, getNowMountainTime, getPermissions, getSecurityServiceUrl, getServiceKey, logDataEditAction, logError, logPageView, logPageViewAndReturnSupportLog, sendEmail };
